import {
  Add,
  DateRange,
  DeleteOutline,
  Edit,
  Email,
  GetApp,
  Smartphone,
  ZoomIn,
  AddCircleOutline,
  Clear,
  Info,
  KeyboardArrowDown,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import "bootstrap-daterangepicker/daterangepicker.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect } from "react";
import { Button, Carousel, Col, InputGroup, Modal, Row } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import ImageLoader from "react-load-image";
import { connect } from "react-redux";
import * as Yup from "yup";
import UrlConstants from "../../../config/UrlConstants";
import { getBuyerAgentMasterTemplateAction } from "./../../../actions/BuyerAgentMasterTemplateActions";
import {
  changeTransactionStatusAction,
  getTransactionDataAction,
  updateTransactionDataAction,
  getLeadSourceOptionsAction,
  getTimezoneListAction,
  createTaskAction,
  userTransactionPaymentAction,
  getUserTransInvoiceAction,
  sendTransPaymentLinkAction,
  getTransTotalPaymentAction,
} from "./../../../actions/TransactionActions";
import {
  getContactsActions,
  myProfileAction,
  getUserTransPaymentStatusAction,
  getBillingPaymentStatusDetails,
} from "./../../../actions/UserActions";
import { getTransactionTypeAction } from "../../../actions/TransactionTypeActions";
import { getAddressFromZipcodeAction } from "./../../../actions/commonActions";
import { getContactByEmailAction } from "./../../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../../actions/SubscriptionReportAction";
import placeholderImage from "./../../../assets/img/property-placeholder.jpg";
import loaderImage from "./../../../assets/img/Ring-Preloader.gif";
import APIUtil from "./../../../config/APIUtil";
import { StatesList } from "./../../../Helper/StatesList";
import InputMask from "react-input-mask";
import NumericInput from "react-numeric-input";
import BrokerageFees from "./../Create/BrokerageFees";
import Buyers from "./../Create/Buyers";
import PhoneNumber from "./../../Common/phoneNumber";
import $ from "jquery";
import {
  cryptoTokenDecode,
  getTimeFromMins,
  formatNumber,
  formatPhoneNumber,
  currencyFormat,
  removeDashFromMobile,
  toastMessage,
  getCurrentDate,
  getContingencyAssignee,
  convertTimeToMinutes,
  getContingencyData,
  toTitleCase,
  checkObjExists,
} from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import * as code from "./../../../config/Constants";
import { TimeZone } from "./../../../Helper/TimeZone";
import UpdateContingencies from "./UpdateContingenciesNew";
import { addPublicFormAction } from "./../../../actions/PublicFormsActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
import DataTable from "react-data-table-component";
import Tooltip from "@material-ui/core/Tooltip";
import { Send } from "@mui/icons-material";
var CryptoJS = require("crypto-js");

var _ = require("lodash");

function Preloader(props) {
  return <img src={loaderImage} />;
}

const initialBillingSettingData = {
  billingSettingStatus: false,
  mid: "",
  developerKey: "",
  apiPassword: "",
};

const initialTransactionPaymentData = {
  paymentType: "",
  amount: "",
  description: "",
  paymentMode: "",
  email: "",
  mobileNumber: "",
};

class TransactionDetailTab extends React.Component {
  constructor(props) {
    super(props);

    this.setStartDate = this.setStartDate.bind(this);
    this.setEndDate = this.setEndDate.bind(this);
    let userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;
    this.state = {
      tempListingAgent: [],
      propertyInfo: false,
      buyerInfo: false,
      agreedInfo: false,
      transactionInfo: false,
      campaignInfo: false,
      showContingencie: "",
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      photoIndex: 0,
      isOpen: false,
      transactionId: this.props.transactionId,
      buyerDataInfo: {
        email: "",
        firstname: "",
        lastName: "",
        mobileNumber: "",
      },
      propertyDataInfo: {
        city: "",
        image: [],
        name: "",
        state: "",
        street: "",
        street1: "",
        zipcode: "",
      },
      priceDataInfo: {
        agreedOpenPrice: "",
        emd: "",
        commission: "",
        heldBy: "",
        agentPercentage: "",
      },
      transactionDataInfo: {
        transactionType: "",
        campaign: "",
        startDate: "",
        closeDate: "",
        contractDate: "",
        campaignName: "",
        listingAgents: [],
      },
      contingencies: {},
      allTransdata: {},
      campaignStyle: [],
      newcampContingencies: [],
      campContingencies: [],
      finalConti: [],
      ownerId: "",
      status: "",
      acceptedFiles: [],
      isInitialState: true,
      showLoader: false,
      reranderOnupdate: false,
      startTransaction: false,
      promptMsg: "",
      initialValues: {
        startDate: "",
        closeDate: "",
        contractDate: "",
      },
      chanedSts: "SCHEDULED",
      showStartDate: true,
      showCloseDate: true,
      updateDate: false,
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      updatedKeys: [],
      newSelCamp: "",
      leadSourceOptions: [],
      fees: [],
      drafted: undefined,
      agentPercentage: "",
      shortNameAccepted: undefined,
      salePriceFocus: false,
      emdFocus: false,
      otherEMD: [],
      draftedEMD: undefined,

      buyers: [],
      buyerId: [],
      isFeesUpdated: false,
      isEMDUpdated: false,
      isBuyerUpdated: false,
      listingAgents: [],
      closingAgents: [],
      listingAgentInfo: false,
      closingAgentInfo: false,
      listingAgentEdit: false,
      closingAgentEdit: false,
      selectedFiles: [],
      nameErrClass: "",
      valErrClass: "",
      editData: {},
      isEdit: false,
      showCampaignModal: false,
      campaignModalMsg: "",
      campaignValues: "",
      userTimezone: "",
      timeZoneList: [],
      buyerAgent: "",
      buyerAgentId: "",
      buyerAgentContactInfo: {},
      contacts: [],
      transactiondata: {},
      permissionarray: [],

      clientDataMissingPrompt: false,

      despositPaymentModal: false,
      amountFocus: false,
      transactionPayment: initialTransactionPaymentData,
      generateLink: false,
      userTransInvoicesData: [],
      paymentUrl: "",
      billingSettingData: initialBillingSettingData,
      sendEmailPropmt: false,
      sendTextPrompt: false,
      formErrors: {},
      disableBtn: false,
      paymentSuccessMsg: "",
      resendPaymentLink: false,
      paymentDetails: {},
      cardProcessBillingItem: false,
    };
  }

  columns = [
    {
      name: "Invoice Number",
      selector: "invoiceNumber",
      sortable: true,
      width: "10%",
    },
    {
      name: "Payment Mode",
      selector: "paymentMode",
      sortable: true,
      width: "10%",
    },
    {
      name: "Requested Amount",
      selector: "requestedAmount",
      sortable: true,
      width: "10%",
    },
    {
      name: "Charged Amount",
      selector: "amountCharged",
      sortable: true,
      width: "10%",
    },

    {
      name: (
        <>
          <div title="Convenience Fee">Conv Fee</div>
        </>
      ),
      selector: "serviceCharge",
      sortable: true,
      width: "10%",
    },
    {
      name: "Tip Amount",
      selector: "tipAmount",
      sortable: true,
      width: "10%",
    },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      width: "22%",
    },
    {
      name: "Status",
      selector: "paymentStatus",
      right: true,
      center: true,
      width: "20%",
    },
  ];

  setStartDate(event, picker) {
    this.setState({
      startDate: picker.startDate,
    });
  }

  setEndDate(event, picker) {
    this.setState({
      closeDate: picker.startDate,
    });
  }

  // Property Info modal
  propertyInfoModal() {
    this.setState({ propertyInfo: !this.state.propertyInfo });
  }

  // Buyer Info modal
  buyerInfoModal() {
    this.setState({ buyerInfo: !this.state.buyerInfo });
  }

  // Agreed Info modal
  agreedInfoModal() {
    this.setState({ agreedInfo: !this.state.agreedInfo, drafted: undefined });
  }

  listingAgentModal() {
    this.setState({ listingAgentInfo: !this.state.listingAgentInfo });
    this.setState({
      listingAgentEdit: false,
    });
  }

  closingAgentModal() {
    this.setState({
      closingAgentInfo: !this.state.closingAgentInfo,
      closingAgentEdit: false,
    });
  }

  // show contigencies popover
  showContingencie = (i) => {
    this.setState({ showContingencie: i == 0 ? "show" : "" });
  };

  // Transaction Info modal
  transactionInfoModal() {
    this.setState({ transactionInfo: !this.state.transactionInfo });
  }

  // Transaction Info modal
  campaignInfoModal() {
    this.setState({ campaignInfo: !this.state.campaignInfo });
  }

  // renderBuyerAgentInfo() {

  // 	if (this.state.userType === message.BUYER ||
  // 		this.state.currentRole === message.BUYER ||
  // 		this.state.userType === message.VENDOR ||
  // 		this.state.currentRole === message.VENDOR) {

  // 	  let transID = this.state.transactionId;
  // 	  this.props.getContactsActions('buyer', transID)
  // 	  .then(res => {
  // 		let buyerAgentName = "";
  // 		let buyerAgentID = "";
  // 		let contactsdata = res.data.data;

  // 		for (let i = 0; i < contactsdata.length; i++) {
  // 		  if (contactsdata[i].roles.includes('62cddf9e169fc5f1c375a83e')) {
  // 			buyerAgentName = contactsdata[i].firstname + " " + contactsdata[i].lastname;
  // 			buyerAgentID = contactsdata[i].contactId;
  // 			this.agentName = buyerAgentName;
  // 			this.agentId = buyerAgentID;
  // 		  }
  // 		}
  // 		this.setState({
  // 		  buyerAgent: this.agentName,
  // 		  buyerAgentId: this.agentId
  // 		})
  // 		this.props.myProfileAction(this.state.buyerAgentId)
  // 		.then(res => {
  // 			this.setState({
  // 				buyerAgentContactInfo: this.props.profileData
  // 			})
  // 		})
  // 	  });
  // 	}

  // }

  componentWillMount() {
    this.setState({
      showLoader: true,
    });
    //get details of transaction
    this.props
      .getTransactionDataAction(this.state.transactionId)
      .then((res) => {
        if (
          this.props.transactionData !== undefined &&
          this.props.transactionData !== null
        ) {
          let data = this.props.transactionData;
          // console.log("data at 287",data)
          this.setState({
            transactiondata: data,
          });
          this.setStateTransactionData(data);
          //   console.log("data at 302", data);
          this.setState({
            showLoader: true,
          });
          this.props
            .getBuyerAgentMasterTemplateAction(
              "?id=" + this.props.transactionData.ownerId
            )
            .then((res) => {
              this.setState({ campaignStyle: this.props.buyerMasterTemplates });
              this.setState({
                showLoader: false,
              });
            });
        }
      })
      .catch((err) => {});

    this.calculateTotalPaymentsMade();
    this.calculateOwedBalance();

    this.props
      .getTransactionTypeAction()
      .then((res) => {
        // this.setState({
        //     showLoader: false
        // });
      })
      .catch((err) => {});

    this.props
      .getLeadSourceOptionsAction()
      .then((res) => {
        this.setState({ leadSourceOptions: res });
      })
      .catch((err) => {});
    this.props.getTimezoneListAction().then((res) => {
      this.setState({ timeZoneList: res });
    });
    // this.renderBuyerAgentInfo();
    // this.renderBuyerAgentContactInfo();
    // set the permission in state.

    let permission = localStorage.getItem("otherInfo");
    let permissionarray;
    if (permission) {
      let bytes = CryptoJS.AES.decrypt(permission, REACT_APP_CRYPTO_SECRET_KEY);
      let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      // console.log("decryptedData39", decryptedData);
      permissionarray = decryptedData.split(",");
      // console.log("permissionarray358", permissionarray);

      this.setState({ permissionarray: permissionarray });
    }

    this.loadUserTransPaymentStatusDetails();
    this.getPaymentStatusDetails();
  }

  loadUserTransPaymentStatusDetails() {
    let ownerId =
      localStorage.getItem("usertype") === "VENDOR"
        ? localStorage.getItem("ownerId")
        : localStorage.getItem("ID");

    this.props.getUserTransPaymentStatusAction(ownerId).then((res) => {
      let data = {
        billingSettingStatus:
          (res && res.data && res.data.isCardProcessEnabled) || false,
      };
      this.setState({
        billingSettingData: data,
      });
    });
  }

  setStateTransactionData(data) {
    var dateObj = new Date();
    var n = dateObj.getTimezoneOffset();
    let sdt = new Date(data.startDate);
    sdt.setMinutes(sdt.getMinutes() + n);
    let edt = new Date(data.endDate);
    edt.setMinutes(edt.getMinutes() + n);
    let cdt = new Date(data.contractDate);
    cdt.setMinutes(cdt.getMinutes() + n);
    let initialValues = {
      startDate: sdt,
      closeDate: edt,
      contractDate: cdt,
    };

    if (data.property) {
      if (data.property.zipcode) {
        let zip = data.property.zipcode.toString();
        if (zip.length > 5) {
          let a = zip.slice(0, 5);
          let b = zip.slice(5, 9);
          let zipcode = a + "-" + b;
          data.property.zipcode = zipcode;
        }
      } else {
        data.property.zipcode = "";
      }
    }
    this.setState(
      {
        allTransdata: data,
        buyerDataInfo: data.dsd.buyer,
        buyerAgentDataInfo: {
          email: data.buyerAgentEmail,
          fname: data.buyerAgentFirstname,
          lname: data.buyerAgentLastName,
          mobile: data.buyerAgentMobileNumber,
        },
        buyers: data.dsd.buyer,
        buyerId: data.dsd.buyerId,
        propertyDataInfo: data.dsd.property || {},
        priceDataInfo: {
          agreedOpenPrice: data.dsd.agreedOpenPrice,
          emd: data.dsd.emd,
          commission: data.dsd.commission,
          heldBy: !!data.dsd.heldBy ? data.dsd.heldBy : "",
          agentPercentage: !!data.dsd.agentPercentage
            ? data.dsd.agentPercentage
            : "",
        },
        transactionDataInfo: {
          transactionType: data.transactionType,
          campaign: data.campaign,
          contractDate: cdt,
          startDate: sdt,
          closeDate: edt,
          campaignName: data.campaignName,
          listingAgents: data.dsd.listingAgents,
        },
        campContingencies: data.contingencies,
        newcampContingencies: data.contingencies,
        finalConti: data.contingencies,
        ownerId: data.ownerId,
        status: data.status,
        isInitialState: false,
        initialValues: initialValues,
        fees: data.dsd.fees,
        oldfees: data.dsd.fees,
        agentPercentage: data.dsd.agentPercentage,
        otherEMD: data.dsd.otherEMD,
        draftedEMD: !!data.draftedEMD ? data.draftedEMD : undefined,
        listingAgents: !!data.dsd.listingAgents ? data.dsd.listingAgents : [],
        closingAgents: !!data.dsd.closingAgents ? data.dsd.closingAgents : [],
        userTimezone: !!data.userTimezone ? data.userTimezone : "",
      },
      () => {
        this.setState({
          showLoader: false,
        });
      }
    );

    // this.getAllContacts();
  }

  updateTransactionDataonchangeofClient() {
    // console.log("update transaction state");
    this.setState({
      showLoader: true,
    });
    this.props
      .getTransactionDataAction(this.state.transactionId)
      .then((res) => {
        // console.log("response", res);
        let data = this.props.transactionData;
        this.setState({
          transactiondata: data,
        });
        this.setState({
          showLoader: false,
        });
      });
  }

  /**
   * @desc update transaction data - Update contingencies from contengencies component
   * @param {*} field
   * @param {*} data
   */
  updateTransactionData(field, data) {
    // console.log("field", field);
    // console.log("field data", data);

    if (field === "fees") {
      this.setState({ fees: data });
    }

    if (field == "drafted") {
      this.setState({ drafted: data });
    }
    if (field === "otherEMD") {
      this.setState({ otherEMD: data });
    }

    if (field == "draftedEMD") {
      this.setState({ draftedEMD: data });
    }

    if (field === "agentPercentage") {
      this.setState({ agentPercentage: data });
    }

    if (field == "updatedFee") {
      this.setState({ isFeesUpdated: true });
    }
    if (field == "updatedEMD") {
      this.setState({ isEMDUpdated: true });
    }
  }
  //Set contingecies for selected campaign
  setContingencyForCamp(selectedcamp) {
    //set contingencies
    let campContingencies = [];
    let camDays = 0;
    for (var i = 0, len = this.state.campaignStyle.length; i < len; i++) {
      let camp = this.state.campaignStyle[i];
      if (camp._id === selectedcamp) {
        campContingencies = camp.contingencies;
        camDays = camp.campaignDays - 1;
      }
    }

    let sdate = moment();
    let edate = moment().subtract(-camDays, "days");

    let contingencies = [];
    for (var key in campContingencies) {
      if (campContingencies.hasOwnProperty(key)) {
        contingencies.push({
          name: key,
          startDate: sdate.format("YYYY-MM-DD"),
          endDate: edate.format("YYYY-MM-DD"),
        });
      }
    }

    this.setState({ newcampContingencies: contingencies });
  }
  //Change transaction status
  changeTransStatus(e) {
    let sts = e.target.value;

    let changedStatus = "";

    if (sts === "INPROGRESS") {
      changedStatus = "start";
    }

    if (sts === "CANCELED") {
      changedStatus = "cancel";
    }
    if (sts === "COMPLETED") {
      this.props.completeTransaction();
    }

    if (changedStatus !== "") {
      this.openConfirmPopup(changedStatus);
    }
  }

  /**
   * @desc action open confirm popup
   * @param {*} sts
   */
  openConfirmPopup(sts) {
    let sd = new Date(this.state.initialValues.startDate);
    let ed = new Date(this.state.initialValues.closeDate);

    let d = new Date();
    if (sd.getTime() < d.getTime()) {
      let selectedcamp = this.state.allTransdata.campaign;
      let camDays = 0;
      for (var i = 0, len = this.state.campaignStyle.length; i < len; i++) {
        let camp = this.state.campaignStyle[i];
        if (camp._id === selectedcamp) {
          camDays = camp.campaignDays - 1;
        }
      }

      let ld = moment(d).subtract(-camDays, "days");
      ld = ld.format("YYYY-MM-DD");
      let nld = new Date(ld);
      if (ed.getTime() > nld.getTime()) {
        ld = ed;
      }

      let initialValues = {
        startDate: d,
        closeDate: new Date(ld),
      };
      this.setState({
        initialValues: initialValues,
      });
    }

    let msg = "";
    if (sts === "start") {
      msg = "Are you sure you want to restart this artwork?";
      this.setState({
        showStartDate: true,
        showCloseDate: true,
        chanedSts: "INPROGRESS",
      });
    }

    if (sts === "cancel") {
      msg =
        "This artwork and all pending tasks will be marked as Canceled. Are you sure want to continue?";
      this.setState({
        showStartDate: false,
        showCloseDate: false,
        chanedSts: "CANCELED",
      });
    }

    if (msg !== "") {
      this.setState({ promptMsg: msg, startTransaction: true });
    }
  }

  closeConfirmPopup() {
    this.setState({ promptMsg: "", startTransaction: false });
  }

  /**
   * @desc change transaction status api call
   * @param {*} val
   */
  changeTransactionStatus(val) {
    let transId = this.state.transactionId;
    let data = { status: this.state.chanedSts };
    data.startDate = new Date(val.startDate);
    data.endDate = new Date(val.closeDate);

    this.props
      .changeTransactionStatusAction(transId, data)
      .then((res) => {
        this.props.getTransactionDataAction(transId).then((res) => {
          if (
            this.props.transactionData !== undefined &&
            this.props.transactionData !== null
          ) {
            this.props.setTransSts(this.state.chanedSts);
            this.setStateTransactionData(res);
            this.setState({
              status: this.state.chanedSts,
              promptMsg: "",
              startTransaction: false,
              updateDate: true,
            });
          }

          if (this.state.chanedSts === "COMPLETED") {
            this.props.updateLeaderBar();
          }
          // if (
          //   this.state.userType === message.ACCTOWNER &&
          //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
          // ) {
          //   this.props.getSubscriptionCounterAction().then((counterRes) => {
          //     localStorage.setItem(
          //       "transactionCount",
          //       counterRes[0].transactionLimitCounter
          //     );
          //   });
          // }
          // if (
          //   this.state.userType === message.VENDOR &&
          //   this.state.currentRole === message.BUYERAGENT &&
          //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
          // ) {
          //   this.props.getSubscriptionCounterAction().then((counterRes) => {
          //     localStorage.setItem(
          //       "transactionCount",
          //       counterRes[0].transactionLimitCounter
          //     );
          //   });
          // }
        });
      })
      .catch((err) => {});
  }

  //Upload images
  uploadImage = (e) => {
    var files = e.target.files;
    var fileNames = [];
    var formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const timestamp = new Date().getTime();
      const newFileName = `${timestamp}_${file.name}`;
      formData.append("file", file, newFileName);
      fileNames.push(newFileName);
      // formData.append("file", files[i]);
      // fileNames.push(files[i].name);

    }
    formData.append("transactionId", this.state.transactionId);
    formData.showSuccessMessage = false;
    let url = `${UrlConstants.uploadPropertyImage}?transactionId=${
      this.state.transactionId
    }`;
    APIUtil.postFormDataMethod(
      url,
      formData,
      true
    ).then((res) => {
      this.setState({ updatedKeys: ["image"] });
      this.updateAPI(fileNames, "images");
    });
  };

  //Delete image
  deleteImage(img) {
    this.setState({ updatedKeys: ["image"] });
    this.updateAPI(img, "delImage");
  }

  updateTranConData(data, keys) {
    let updatedkeys = [];
    updatedkeys.push(keys);

    this.setState({ campContingencies: data, updatedKeys: updatedkeys }, () => {
      if (!this.state.isInitialState) {
        this.updateAPI(data, "conti-up");
      }
    });
  }

  updateClientData(data, keys) {
    // console.log("at transaction detail tab");
    let updatedkeys = [];
    updatedkeys.push(keys);

    this.setState({ buyers: data, updatedKeys: updatedkeys }, () => {
      if (!this.state.isInitialState) {
        this.updateAPI(data, "buyer");
      }
    });
  }

  updateClientId(data, keys) {
    let updatedkeys = [];
    updatedkeys.push(keys);

    this.setState({ buyerId: data, updatedKeys: updatedkeys }, () => {
      if (!this.state.isInitialState) {
        this.updateAPI(data, "buyerId");
      }
    });
  }

  updateArtistData(data, keys) {
    let updatedkeys = [];
    updatedkeys.push(keys);

    this.setState({ listingAgents: data, updatedKeys: updatedkeys }, () => {
      if (!this.state.isInitialState) {
        this.updateAPI(data, "listingAgents");
      }
    });
  }

  updateGuardianData(data, keys) {
    let updatedkeys = [];
    updatedkeys.push(keys);

    this.setState({ closingAgents: data, updatedKeys: updatedkeys }, () => {
      if (!this.state.isInitialState) {
        this.updateAPI(data, "closingAgents");
      }
    });
  }

  //Call api for update transaction
  //@param : data updated data
  //@param : model - which model data should be updated
  updateAPI(data, model) {
    // console.log("=====data=====", data);
    // console.log("=====data=====model", model);

    this.setState({
      showLoader: true,
    });

    let property = this.state.propertyDataInfo;
    let price = this.state.priceDataInfo;
    let camp = this.state.campDataInfo;
    let trans = this.state.transactionDataInfo;
    let campAll = this.state.campContingencies;
    let shortName = this.state.allTransdata.shortName;
    let dsd = this.state.allTransdata.dsd;

    let multibuyers = this.state.buyers;
    for (let b = 0; b < multibuyers.length; b++) {
      if (multibuyers[b].mobileNumber) {
        multibuyers[b].mobileNumber = removeDashFromMobile(
          multibuyers[b].mobileNumber.toString()
        );
      }
    }

    for (let i = 0; i < campAll.length; i++) {
      campAll[i].startDate = trans.startDate;

      let d1 = new Date(trans.startDate);
      let d = new Date(campAll[i].endDate);

      if (d.getTime() < d1.getTime()) {
        campAll[i].endDate = new Date(trans.closeDate);
      }

      if (campAll[i].assignee == "no") {
        delete campAll[i].assignee;
      }
    }

    if (model === "property") {
      shortName = data.shortName;
      delete data.shortName;
      property = data;
      delete dsd.property;
      dsd.property = data;
    }
    if (model === "price") {
      price = data;
      delete dsd.emd;
      delete dsd.commission;
      delete dsd.agreedOpenPrice;
      delete dsd.heldBy;
      dsd.emd = price.emd;
      dsd.commission = price.commission;
      dsd.agreedOpenPrice = price.agreedOpenPrice;
      dsd.heldBy = price.heldBy;
    }
    if (model === "camp") {
      camp = data;
    }
    if (model === "trans") {
      trans = data;
    }
    let transactData = {
      property: property,
      buyer: multibuyers,
      buyerId: this.state.buyerId,
      emd: price.emd,
      commission: price.commission,
      agreedOpenPrice: price.agreedOpenPrice,
      heldBy: price.heldBy,
      draft: false,
      transactionType: trans.transactionType,
      startDate: trans.startDate,
      contractDate: trans.contractDate,
      endDate: trans.closeDate,
      campaign: trans.campaign,
      campaignName: trans.campaignName,
      contingencies: campAll,
      updatedKeys: this.state.updatedKeys,
      shortName: shortName,
      listingAgents: this.state.listingAgents,
      closingAgents: this.state.closingAgents,
      dsd: dsd,
    };

    if (model === "trans") {
      if (trans.campaign !== data.campaign) {
        let campAllNew = this.state.newcampContingencies;

        for (let i = 0; i < campAllNew.length; i++) {
          campAllNew[i].startDate = data.startDate;

          let d1 = new Date(data.startDate);
          let d = new Date(campAllNew[i].endDate);

          if (d.getTime() < d1.getTime()) {
            campAllNew[i].endDate = new Date(data.closeDate);
          }

          if (campAllNew[i].assignee == "no") {
            delete campAllNew[i].assignee;
          }
        }

        transactData.contingencies = campAllNew;
      } else {
        for (let i = 0; i < campAll.length; i++) {
          campAll[i].startDate = data.startDate;

          let d1 = new Date(data.startDate);
          let d = new Date(campAll[i].endDate);

          if (d.getTime() < d1.getTime()) {
            campAll[i].endDate = new Date(data.closeDate);
          }
          if (campAll[i].assignee == "no") {
            delete campAll[i].assignee;
          }
        }
        transactData.contingencies = campAll;
      }
    }

    if (model === "buyer") {
      delete transactData.dsd.buyer;
      transactData.dsd.buyer = data;
    }

    if (model === "status") {
      transactData.status = data.status;
    }

    if (model === "images") {
      for (let i = 0; i < data.length; i++) {
        property.image.push(data[i]);
      }
      transactData.dsd.property = property;
    }
    if (model === "delImage") {
      var imagesAr = [];

      imagesAr = property.image.filter((e) => {
        return !(e == data);
      });

      property.image = imagesAr;
      transactData.property = property;
    }

    if (model === "conti-up") {
      transactData.contingencies = data;
    }

    if (transactData.campaign == "") {
      delete transactData.campaign;
    }

    if (transactData.property) {
      let zip = transactData.property.zipcode.toString();
      if (zip.length > 5) {
        let zipcode = removeDashFromMobile(transactData.property.zipcode);
        transactData.property.zipcode = zipcode;
      }
    }

    transactData.dsd.fees = this.state.fees;

    // console.log("transactData.dsd.fees 1", transactData.dsd.fees);
    // console.log("this.state.fees", this.state.fees);

    if (this.state.drafted !== undefined) {
      let fees = this.state.fees;
      fees.push(this.state.drafted);
      transactData.dsd.fees = fees;
    }
    // console.log("transactData.dsd.fees 2", transactData.dsd.fees);
    transactData.dsd.otherEMD = this.state.otherEMD;

    if (this.state.draftedEMD !== undefined) {
      let otherEMD = this.state.otherEMD;
      otherEMD.push(this.state.draftedEMD);
      transactData.dsd.otherEMD = otherEMD;
    }

    transactData.dsd.agentPercentage = this.state.agentPercentage;
    if (this.state.agentPercentage == "") {
      transactData.dsd.agentPercentage = this.props.profileData.agentPercentage;
    }

    //calculate amount
    let commissionAmt =
      (transactData.agreedOpenPrice * transactData.commission) / 100;
    let agentPercentageAmt =
      (commissionAmt * transactData.dsd.agentPercentage) / 100;
    let brokerPercentageAmt = commissionAmt - agentPercentageAmt;

    let fees = transactData.dsd.fees;

    for (let j = 0; j < fees.length; j++) {
      if (fees[j] !== null && fees[j].name === "Brokerage Fee") {
        fees[j].value = brokerPercentageAmt;
      }
    }
    transactData.dsd.fees = fees;
    // console.log("transactData.dsd.fees 3", transactData.dsd.fees);

    if (model === "price") {
      if (
        this.state.agentPercentage !== this.state.allTransdata.agentPercentage
      ) {
        transactData.updatedKeys.push("agentPercentage");
        transactData.updatedKeys.push("Brokerage Fee");
      }
      if (this.state.isFeesUpdated) {
        transactData.updatedKeys.push("fees");
      }
      if (this.state.isEMDUpdated) {
        transactData.updatedKeys.push("otherEMD");
      }
    }

    if (
      this.state.isBuyerUpdated &&
      !transactData.updatedKeys.includes("buyers")
    ) {
      transactData.updatedKeys.push("buyers");
    }

    if (model == "listingAgents") {
      //  transactData= this.setAgentData(data, transactData, true);
      let updatedtrasactiondata = this.setAgentData(data, transactData, true);
      transactData.dsd.listingAgents = updatedtrasactiondata.listingAgents;
    }

    if (model == "closingAgents") {
      // transactData.dsd = this.setAgentData(data, transactData, false);
      let updatedtrasactiondata = this.setAgentData(data, transactData, false);
      transactData.dsd.closingAgents = updatedtrasactiondata.closingAgents;
    }

    this.props
      .updateTransactionDataAction(this.state.transactionId, transactData)
      .then((res) => {
        if (res !== undefined && res !== null) {
          let data = res;
          this.setStateTransactionData(res);
          this.setState({
            propertyInfo: false,
            buyerInfo: false,
            agreedInfo: false,
            transactionInfo: false,
            campaignInfo: false,
            listingAgentInfo: false,
            closingAgentInfo: false,
            showLoader: false,
            fees: res.dsd.fees,
            isFeesUpdated: false,
            otherEMD: res.dsd.otherEMD,
            isEMDUpdated: false,
            isBuyerUpdated: false,
            listingAgentEdit: false,
            closingAgentEdit: false,
            isEdit: false,
          });

          //update data to parent component -Details.jsx
          this.props.isDataUpdate(this.props.updatedTransData.property);
          this.props.isTransactionUpdate(data);
          this.props
            .getTransactionDataAction(this.state.transactionId)
            .then((res) => {
              if (res !== undefined && res !== null) {
                this.setStateTransactionData(res);
              }
            });

          this.calculateTotalPaymentsMade();
        }
      })
      .catch((err) => {
        this.props
          .getTransactionDataAction(this.state.transactionId)
          .then((res) => {
            if (res !== undefined && res !== null) {
              this.setStateTransactionData(res);
            }
          });
      });

    this.updateTransactionDataonchangeofClient();
  }

  /**
   * @desc setting agents data properly
   */
  setAgentData(data, transactData, isListing) {
    // console.log("data 1038", data);
    data = data[0];
    if (
      data.mobileNumber !== "" ||
      data.firstname !== "" ||
      data.lastname !== "" ||
      (data.email !== undefined && data.email.address !== "") ||
      (data.companyInformation !== undefined &&
        data.companyInformation.name !== "")
    ) {
      let agents = [];
      let agent = {};
      agent.mobileNumber = !!data.mobileNumber
        ? removeDashFromMobile(data.mobileNumber.toString())
        : "";
      agent.firstname = data.firstname;
      agent.lastname = data.lastname;
      agent.email = data.email;
      agent.companyInformation = data.companyInformation;
      agents.push(agent);
      if (isListing) {
        transactData.listingAgents = agents;
      } else {
        transactData.closingAgents = agents;
      }
    } else {
      if (
        (data.mobileNumber == "" &&
          data.firstname == "" &&
          data.lastname == "" &&
          data.email !== undefined &&
          data.email.address == "") ||
        (data.companyInformation !== undefined &&
          data.companyInformation.name == "")
      ) {
        if (isListing) {
          transactData.listingAgents = [];
        } else {
          transactData.closingAgents = [];
        }
      } else {
        if (isListing) {
          transactData.listingAgents = this.state.listingAgents;
        } else {
          transactData.closingAgents = this.state.closingAgents;
        }
      }
    }

    return transactData;
  }

  getLeadSourceName(id) {
    let found = "";
    this.state.leadSourceOptions.forEach((e) => {
      if (e._id == id) {
        found = e.type;
      }
    });
    return found;
  }

  //get tasks by day for leader bar
  getTaskStatusByDay(allTask, transStatus) {
    let taskStatusByDay = [];
    let tasksByDay = [];
    tasksByDay = _.groupBy(allTask, function(t) {
      return t.day;
    });

    for (var key in tasksByDay) {
      let tasks = tasksByDay[key];

      if (tasks.length === 0) {
        //no tasks
        taskStatusByDay[key] = "no-tasks";
      } else {
        let schTasks = [];
        let overdueTasks = [];
        let doneTasks = [];

        schTasks = tasks.filter((t) => {
          t.eventEndDate = new Date(
            moment(t.eventEndDate).format("MM/DD/YYYY ") +
              getTimeFromMins(t.time)
          );
          return (
            t.status.toLowerCase() == "scheduled" &&
            moment(t.eventEndDate) >= moment()
          );
        });

        if (transStatus === "INPROGRESS") {
          overdueTasks = tasks.filter((t) => {
            t.eventEndDate = new Date(
              moment(t.eventEndDate).format("MM/DD/YYYY ") +
                getTimeFromMins(t.time)
            );
            return (
              t.status.toLowerCase() == "scheduled" &&
              moment(t.eventEndDate) < moment()
            );
          });
        }

        doneTasks = tasks.filter((t) => {
          return t.status.toLowerCase() == "completed";
        });

        if (
          schTasks.length > 0 &&
          overdueTasks.length === 0 &&
          doneTasks.length === 0
        ) {
          taskStatusByDay[key] = "scheduled";
        } else if (
          doneTasks.length > 0 &&
          overdueTasks.length === 0 &&
          schTasks.length === 0
        ) {
          taskStatusByDay[key] = "completed";
        } else if (overdueTasks.length > 0) {
          taskStatusByDay[key] = "overdue";
        } else {
          taskStatusByDay[key] = "no-tasks";
        }
      }
    }
    return taskStatusByDay;
  }

  // calculateOwedBalance() {
  //   let totalOwedBalance = 0;
  //   let price = this.props.transactionData.dsd.agreedOpenPrice;
  //   let deposit = Number(this.props.transactionData.dsd.emd);
  //   let fees = this.props.transactionData.dsd.fees;
  //   let payments = this.props.transactionData.dsd.otherEMD;

  //   let feesTotal = fees.reduce((acc, curr) => {
  //     if (curr.name !== "Brokerage Fee") {
  //       acc = acc + Number(curr.value);
  //     }
  //     return acc;
  //   }, 0);

  //   let paymentsTotal = payments.reduce((acc, curr) => {
  //     acc = acc + Number(curr.value);
  //     return acc;
  //   }, 0);

  //   if (fees.length === 0) {
  //     totalOwedBalance = price - deposit;
  //   } else {
  //     totalOwedBalance = feesTotal + price - deposit - paymentsTotal;
  //   }

  //   return totalOwedBalance;
  // }

  calculateOwedBalance() {
    let totalOwedBalance = 0;
    let price = Number(this.props.transactionData.dsd.agreedOpenPrice);
    let deposit =
      this.props.transPaymentData && this.props.transPaymentData.totalDeposit
        ? Number(this.props.transPaymentData.totalDeposit)
        : 0;

    let fees = this.props.transactionData.dsd.fees;

    let feesTotal = fees.reduce((acc, curr) => {
      if (curr.name !== "Brokerage Fee") {
        acc = acc + Number(curr.value);
      }
      return acc;
    }, 0);

    let totalPaymentAmount =
      this.props.transPaymentData && this.props.transPaymentData.totalCostAmount
        ? Number(this.props.transPaymentData.totalCostAmount)
        : 0;

    if (fees.length === 0) {
      totalOwedBalance = price - deposit;
    } else {
      totalOwedBalance = feesTotal + price - deposit - totalPaymentAmount;
    }

    return totalOwedBalance;
  }

  calculateTotalPaymentsMade() {
    // let deposit = Number(this.props.transactionData.dsd.emd);
    // let payments = this.props.transactionData.dsd.otherEMD;
    // // console.log("payments", payments);
    // let totalPayments = 0;

    // if (payments.length === 0) {
    //   totalPayments = this.props.transactionData.dsd.emd;
    // } else {
    //   // totalPayments = payments.map(
    //   //   (payment) => (deposit += Number(payment.value))
    //   // );
    //   totalPayments = payments.reduce((acc, curr) => {
    //     acc = acc + Number(curr.value);
    //     return acc;
    //   }, deposit);
    // }

    // return totalPayments;
    this.props
      .getTransTotalPaymentAction(this.state.transactionId)
      .then((res) => {});
  }

  /**
   *
   * @desc update buyers data
   * @param {*} k
   * @param {*} buyers
   */
  updateBuyersData(k, buyers) {
    if (k == "buyers") {
      this.setState({ buyers: buyers }, () => {
        this.updateAPI(buyers, "buyer");
      });
    }

    if (k == "updatedBuyer") {
      this.setState({ isBuyerUpdated: true });
    }
  }

  /**
   * @desc check vendor email is exist or not - apicall
   */
  checkVendor = (email) =>
    new Promise((resolve, reject) => {
      if (email != "") {
        this.props.getContactByEmailAction(email).then((res) => {
          if (res == "Unauthorized") {
            resolve({ contact: "Unauthorized" });
            toastMessage(code.ERROR, message.INVALID_USER_SELECTION);
          } else {
            if (Object.keys(res).length > 0) {
              var contact = {
                firstname: res.firstname,
                lastname: res.lastname,
                mobileNumber: formatPhoneNumber(res.mobileNumber),
                email: email,
                companyInformation: !!res.companyInformation
                  ? res.companyInformation
                  : { name: "" },
              };
              resolve({ contact: contact });
            } else {
              resolve({ contact: "" });
            }
          }
        });
      }
    });

  /**
   * @desc Get transaction start end date with format
   */
  getTransactionDate(propDate, stateDate) {
    let date =
      this.props.updated && !this.state.updateDate
        ? new Date(propDate)
        : new Date(stateDate);
    let d = new Date();
    let n = d.getTimezoneOffset();
    let dt = new Date(date);
    dt.setMinutes(dt.getMinutes() + n);
    let transDate =
      dt.getMonth() + 1 + "/" + dt.getDate() + "/" + dt.getFullYear();
    return transDate;
  }

  transactionInfo() {
    return {
      _id: this.state.transactionId,
      property: this.state.propertyDataInfo,
      buyer: this.state.buyerDataInfo,
      buyers: this.state.buyerDataInfo,
      buyerId: this.state.buyerDataInfo,
      emd: this.state.priceDataInfo.emd || "0",
      commision: this.state.priceDataInfo.commission,
      agreedOpenPrice: this.state.priceDataInfo.agreedOpenPrice,
      agentPercentage: this.state.priceDataInfo.agentPercentage,
      heldBy: !!this.state.priceDataInfo.heldBy
        ? this.state.priceDataInfo.heldBy
        : "",
      draft: false,
      transactionType: this.state.transactionDataInfo.transactionType,
      startDate: this.state.transactionDataInfo.startDate,
      endDate: this.state.transactionDataInfo.closeDate,
      campaign: this.state.transactionDataInfo.campaign,
      listingAgents: this.state.transactionDataInfo.listingAgents,
      contingencies: this.state.campContingencies,
      isInitialState: this.state.isInitialState,
    };
  }
  // 	 /**
  //    * @desc Add otherEMD to state
  //    */
  addOtherEMD(e) {
    let otherEMDLabel = $(".other-deposit-label ul li.title input").val();
    let otherEMDVal = $(".other-deposit-label .value input").val();

    if (otherEMDLabel !== "" && otherEMDVal !== "") {
      let newF = { name: otherEMDLabel, value: otherEMDVal };
      let otherEMD = this.state.otherEMD;
      otherEMD.push(newF);
      this.setState({ otherEMD });
      this.updateTransactionData("otherEMD", otherEMD);
      this.setState({ draftedEMD: undefined });
      this.updateTransactionData("draftedEMD", undefined);
      this.updateTransactionData("updatedEMD", []);

      $(".other-deposit-label .title input").val("");
      $(".other-deposit-label .value input").val("");
      this.setState({ nameErrClass: "", valErrClass: "" });
    } else {
      if (otherEMDLabel == "") {
        this.setState({ nameErrClass: code.ERROR });
      } else {
        this.setState({ nameErrClass: "" });
      }
      if (otherEMDVal == "") {
        this.setState({ valErrClass: code.ERROR });
      } else {
        this.setState({ valErrClass: "" });
      }
    }
  }

  /**
   * @desc save data as draft
   * drafted EMD means data in input but not saved then also need to consider as deposit
   */
  draftedEMD() {
    let feeLabel = $(".other-deposit-label ul li.title input").val();
    let feeVal = $(".other-deposit-label .value input").val();
    if (feeLabel !== "" && feeVal !== "") {
      let draftedEMD = { name: feeLabel, value: feeVal };

      this.setState({ draftedEMD: draftedEMD });
      this.updateTransactionData("draftedEMD", draftedEMD);
      this.updateTransactionData("updatedEMD", []);
    }

    if (feeLabel !== "") {
      this.setState({ nameErrClass: "" });
    }
    if (feeVal !== "") {
      this.setState({ valErrClass: "" });
    }
  }

  //delete deposit record
  deleteFeesRecord(e, ind, name) {
    let fees = this.state.otherEMD;
    if (ind !== "") {
      delete fees[ind];
      var ar = fees.filter(function(el) {
        return el != null;
      });

      this.setState({ otherEMD: ar });
      this.updateTransactionData("otherEMD", ar);
      this.updateTransactionData("updatedEMD", []);
    }
  }

  //edit deposit record
  editFeesRecord(e, ind) {
    let fees = this.state.otherEMD;
    let selfee = fees[ind];
    selfee.ind = ind;
    this.setState({ editData: selfee, isEdit: true });
  }

  //update fees record
  updateFeesRecord(e) {
    let fees = this.state.otherEMD;
    let ind = this.state.editData.ind;

    let feeLabel = $(".other-deposit-label ul li.title input").val();
    let feeVal = $(".other-deposit-label .value input").val();

    if (feeLabel !== "" && feeVal !== "") {
      fees[ind].name = feeLabel;
      fees[ind].value = feeVal;

      this.setState({ fees });
      this.updateTransactionData("otherEMD", fees);

      $(".other-emd-label .title input").val("");
      $(".other-emd-label .value input").val("");
      this.setState({ isEdit: false });
      this.updateTransactionData("updatedEMD", []);
    }
  }
  closeCampaignModal() {
    this.transactionInfoModal();
    this.setState({ showCampaignModal: false, campaignValues: "" });
  }

  getAllContacts() {
    let rolename = "admin";
    if (cryptoTokenDecode().usertype === message.VENDOR) {
      rolename = "ep";
      this.props
        .getContactsActions(
          rolename,
          "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
        )
        .then((epContactsRes) => {
          this.setState({
            contacts: this.props.contacts || [],
          });
        });
    } else {
      this.props.getContactsActions().then((contactRes) => {
        this.setState({
          contacts: this.props.contacts || [],
        });
      });
    }
  }

  sendForms() {
    if (
      !this.state.transactiondata.dsd.buyer[0].mobileNumber &&
      !this.state.transactiondata.dsd.buyer[0].email
    ) {
      this.setState({
        clientDataMissingPrompt: true,
      });
    } else {
      let newEventStart = moment();
      let newEventEnd = moment();
      let newEventTime = convertTimeToMinutes(
        moment(newEventStart).get("hour") +
          ":" +
          moment(newEventStart).get("minutes")
      );

      let appointmentDate = getContingencyData(
        this.state.allTransdata.contingencies,
        "First Appointment",
        "startDate"
      );

      let newPublicForm = {
        form: "intake",
        transactionId: this.state.transactionId,
        expiresOn: new Date(moment(appointmentDate).subtract(5, "days")),
        auth: false,
      };
      this.props
        .addPublicFormAction(newPublicForm)
        .then((newPubResIntake) => {});

      newPublicForm = {
        form: "consent",
        transactionId: this.state.transactionId,
        expiresOn: new Date(moment(appointmentDate).subtract(5, "days")),
        auth: false,
      };
      this.props
        .addPublicFormAction(newPublicForm)
        .then((newPubResConsent) => {});

      // if email is present
      if (this.state.transactiondata.dsd.buyer[0].email) {
        this.sendIntakeFormOnEmail(newEventStart, newEventEnd, newEventTime);
        this.sendConsentFormOnEmail(newEventStart, newEventEnd, newEventTime);
      }

      // if mobile is present
      if (this.state.transactiondata.dsd.buyer[0].mobileNumber) {
        this.sendIntakeFormOnMobile(newEventStart, newEventEnd, newEventTime);
        this.sendConsentFormOnMobile(newEventStart, newEventEnd, newEventTime);
      }
    }
  }

  sendIntakeFormOnEmail(newEventStart, newEventEnd, newEventTime) {
    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        "Intake Form for @client_firstname @client_lastname",
      ],
      communicationTo: ["@client_email"],
      communicationType: "EMAIL",
      contingency: "Client",
      day: 0,
      description: [
        '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a>!</p><p></p><p>The intake form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@intake_form_url</p>',
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Intake Form - Email",
      transactionId: this.state.transactionId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(code.SUCCESS, "Intake Form sent on client email");
        }
      });
    }
  }

  sendIntakeFormOnMobile(newEventStart, newEventEnd, newEventTime) {
    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [""],
      communicationTo: ["@client_phone"],
      communicationType: "TEXT",
      contingency: "Client",
      day: 0,
      description: [
        "Hey @client_firstname! We emailed you the intake form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!",
        ,
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Intake Form - Text",
      transactionId: this.state.transactionId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(
            code.SUCCESS,
            "Intake Form sent on client mobile number"
          );
        }
      });
    }
  }

  sendConsentFormOnEmail(newEventStart, newEventEnd, newEventTime) {
    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        "Consent Form for @client_firstname @client_lastname",
      ],
      communicationTo: ["@client_email"],
      communicationType: "EMAIL",
      contingency: "Client",
      day: 0,
      description: [
        '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a>!</p><p></p><p>The consent form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@consent_form_url</p>',
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Consent Form - Email",
      transactionId: this.state.transactionId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(code.SUCCESS, "Consent Form sent on client email");
          //   console.log(createEventRes);
        }
      });
    }
  }

  sendConsentFormOnMobile(newEventStart, newEventEnd, newEventTime) {
    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [""],
      communicationTo: ["@client_phone"],
      communicationType: "TEXT",
      contingency: "First Appointment",
      day: 0,
      description: [
        "Hey @client_firstname! We emailed you the consent form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!",
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Consent Form - Text",
      transactionId: this.state.transactionId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(
            code.SUCCESS,
            "Consent Form sent on client mobile number"
          );
          //   console.log(createEventRes);
        }
      });
    }
  }

  despositPaymentModal() {
    this.setState({
      despositPaymentModal: !this.state.despositPaymentModal,
    });
  }

  loadUserTransInvoiceList() {
    this.props
      .getUserTransInvoiceAction(this.state.transactionId)
      .then((res) => {
        this.setState({
          userTransInvoicesData: res.data || [],
        });
      });
  }

  findFormErrors(values) {
    const newErrors = {};
    if (this.state.sendEmailPropmt) {
      if (values.email) {
        if (
          !values.email.match("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$")
        ) {
          newErrors.email = message.ENTER_VALID_EMAIL;
        }
      } else {
        newErrors.email = message.ENTER_EMAIL;
      }
    }
    if (this.state.sendTextPrompt) {
      if (values.mobileNumber) {
        if (
          values.mobileNumber.length !== 10 ||
          (values.mobileNumber.length === 10 &&
            values.mobileNumber.charAt(0) === "0")
        ) {
          newErrors.mobileNumber = message.ENTER_VALID_MOBILE;
        }
      } else {
        newErrors.mobileNumber = message.ENTER_MOBILE_NUMBER;
      }
    }
    if (values.amount) {
      if (values.amount > this.state.allTransdata.dsd.agreedOpenPrice) {
        newErrors.amount = message.AMOUNT_INVALID;
      }
      if (values.paymentType) {
        if (values.paymentType === "DEPOSIT") {
          if (values.amount > this.calculateOwedBalance()) {
            newErrors.amount = message.DEPOSIT_AMOUNT_INVALID;
          }
        }
        if (values.paymentType === "PARTIAL PAYMENT") {
          if (values.amount > this.calculateOwedBalance()) {
            newErrors.amount = message.PARTIAL_AMOUNT_INVALID;
          }
        }
        if (values.paymentType === "FULL PAYMENT") {
          if (values.amount !== this.state.allTransdata.dsd.agreedOpenPrice) {
            newErrors.amount = message.FULL_AMOUNT_INVALID;
          }
        }
      }
    }
    return newErrors;
  }

  userTransactionPayment(values) {
    //this.setState({ showLoader: true });

    const newErrors = this.findFormErrors(values);
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      this.setState({ formErrors: newErrors });
    } else {
      this.setState({ formErrors: {} });

      let data = {
        transactionId: this.state.transactionId,
        amount: values.amount,
        description: values.description,
        invoiceType: values.paymentType,
        paymentMethod: values.paymentMode,
        firstName: this.checkClientDetailsExists("fname")
          ? this.state.transactiondata.dsd.buyer[0].firstname
          : "",
        lastName: this.checkClientDetailsExists("lname")
          ? this.state.transactiondata.dsd.buyer[0].lastname
          : "",
        email: this.checkClientDetailsExists("email")
          ? this.state.transactiondata.dsd.buyer[0].email
          : "",
      };
      this.props.userTransactionPaymentAction(data).then((res) => {
        // console.log("userTransactionPaymentAction res", res);
        if (res.status === code.OK) {
          this.setState({ disableBtn: true });
          // let resetPaymentForm = {
          //   amount: "",
          //   description: "",
          //   paymentType: "",
          //   paymentMode: "",
          // };
          // this.setState({
          //   showLoader: false,
          //   transactionPayment: resetPaymentForm,
          // });

          if (res && res.data && res.data.paymentUrl) {
            this.setState({
              paymentUrl: res.data.paymentUrl,
              generateLink: true,
            });
          }
          let successMsg =
            values.paymentMode === "CARD"
              ? "Payment link generated successfully"
              : "Payment done successfully";
          this.setState({ paymentSuccessMsg: successMsg });
          toastMessage(code.SUCCESS, successMsg);
          this.calculateTotalPaymentsMade();
          this.loadUserTransInvoiceList();
        } else {
          // console.log("userTransactionPaymentAction err", res);
          this.setState({ showLoader: false });
          toastMessage(
            code.ERROR,
            (res && res.data) || message.SOMETHING_WENT_WRONG
          );
        }
      });
    }
  }

  setAmount(paymentType, setFieldValue) {
    setFieldValue("amount", this.calculateOwedBalance());
    // if (paymentType === "DEPOSIT") {
    //   setFieldValue("amount", this.state.allTransdata.dsd.emd);
    // }
    // if (paymentType === "PARTIAL PAYMENT" || paymentType === "FULL PAYMENT") {
    //   setFieldValue("amount", this.calculateOwedBalance());
    // }
  }

  checkClientDetailsExists(flag) {
    if (
      this.state.transactiondata &&
      this.state.transactiondata.dsd &&
      this.state.transactiondata.dsd.buyer.length > 0 &&
      this.state.transactiondata.dsd.buyer[0]
    ) {
      if (flag === "email" && this.state.transactiondata.dsd.buyer[0].email) {
        return true;
      }
      if (
        flag === "mobile" &&
        this.state.transactiondata.dsd.buyer[0].mobileNumber
      ) {
        return true;
      }
      if (
        flag === "fname" &&
        this.state.transactiondata.dsd.buyer[0].firstname
      ) {
        return true;
      }
      if (
        flag === "lname" &&
        this.state.transactiondata.dsd.buyer[0].lastname
      ) {
        return true;
      }
    }
    return false;
  }

  sendPaymentLink(flag, values) {
    //this.setState({ showLoader: true });

    let commTo = "";
    //let successMsg = "";

    if (flag === "EMAIL") {
      commTo = values.email
        ? values.email
        : this.state.transactiondata.dsd.buyer[0].email;
      // successMsg = "Payment link sent on client's email";
    }
    if (flag === "TEXT") {
      commTo = values.mobileNumber
        ? values.mobileNumber
        : this.state.transactiondata.dsd.buyer[0].mobileNumber;
      // successMsg = "Payment link sent on client's mobile number";
    }

    let data = {
      communicationType: flag,
      amount: values.amount,
      paymentUrl: this.state.paymentUrl,
      receiver: commTo,
    };

    const newErrors = this.findFormErrors(values);
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      this.setState({ formErrors: newErrors });
    } else {
      this.setState({ formErrors: {} });

      this.props.sendTransPaymentLinkAction(data).then((res) => {
        // this.setState({ showLoader: false });
        // if (res.status === code.OK) {
        //   toastMessage(code.SUCCESS, successMsg);
        // }
      });
    }
  }

  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  getTypeDescription(invoice) {
    let typeDescription = "";

    typeDescription = invoice.invoiceType
      ? toTitleCase(invoice.invoiceType)
      : "";
    if (invoice.description) {
      if (invoice.description.length > 60) {
        typeDescription =
          typeDescription + " (" + invoice.description.slice(0, 60) + "...)";
      } else {
        typeDescription = typeDescription + " (" + invoice.description + ")";
      }
    }

    return typeDescription;
  }

  setResendPaymentData(invoice) {
    // console.log("setResendPaymentData invoice", invoice);
    let data = {
      paymentMode: invoice.paymentMethod,
      amount: invoice.amountCharged,
      paymentType: invoice.invoiceType,
      description: invoice.description,
      email: "",
      mobileNumber: "",
    };
    this.setState({
      transactionPayment: data,
      disableBtn: true,
      generateLink: true,
      paymentUrl: invoice.paymentUrl,
    });
  }

  resetForm() {
    this.setState({
      formErrors: {},
      generateLink: false,
      disableBtn: false,
      sendEmailPropmt: false,
      sendTextPrompt: false,
      paymentSuccessMsg: "",
    });
  }

  getPaymentStatusDetails() {
    let ownerId =
      localStorage.getItem("usertype") === "VENDOR"
        ? localStorage.getItem("ownerId")
        : localStorage.getItem("ID");
    const today = moment();
    let data = {
      userId: ownerId,
      // invoicePeriod: today.format("YYYYMM"),
      invoiceItems: ["cardprocess"],
    };
    this.props
      .getBillingPaymentStatusDetails(data)
      .then((res) => {
        this.setState({ paymentDetails: (res && res.data) || {} });
      })
      .catch((err) => {
        console.log(err);
      });

    //return paymentDetails;
  }

  renderOptions = () => {
    // Base options
    const options = [
      { value: "", label: "Select" },
      { value: "CASH", label: "Cash" },
    ];

    // Conditionally add an extra option based on the state
    if (
      this.state.billingSettingData &&
      this.state.billingSettingData.billingSettingStatus === true &&
      (this.state.paymentDetails &&
        this.state.paymentDetails.hasOwnProperty("cardprocess") &&
        this.state.paymentDetails.cardprocess === true)
    ) {
      options.push({ value: "CARD", label: "Card" });
    }

    return options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ));
  };

  render() {
    let defaultValue = "";
    let defVal = "";

    if (this.state.allTransdata.draftedEMD !== undefined) {
      defaultValue = this.props.transactionData.draftedEMD.name;
      defVal = this.props.transactionData.draftedEMD.value;
    }

    let label = this.state.isEdit ? this.state.editData.name : defaultValue;
    let val = this.state.isEdit ? this.state.editData.value : defVal;

    let modifiedDate = "";
    if (this.state.allTransdata.modifiedDate !== undefined) {
      let date = new Date(this.state.allTransdata.modifiedDate);
      modifiedDate =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    }
    let transCdate = "";
    if (this.state.allTransdata.contractDate !== undefined) {
      transCdate = this.getTransactionDate(
        this.props.updatedData.contractDate,
        this.state.allTransdata.contractDate
      );
    }
    let transSdate = "";
    if (this.state.allTransdata.startDate !== undefined) {
      transSdate = this.getTransactionDate(
        this.props.updatedData.startDate,
        this.state.allTransdata.startDate
      );
    }

    let transEdate = "";
    if (this.state.allTransdata.endDate !== undefined) {
      transEdate = this.getTransactionDate(
        this.props.updatedData.endDate,
        this.state.allTransdata.endDate
      );
    }

    var stateDropDownValue = [];
    for (var key in StatesList) {
      var opt = (
        <option key={key} value={key}>
          {StatesList[key]}
        </option>
      );
      stateDropDownValue.push(opt);
    }

    let campaignList = [];
    for (var i = 0, len = this.state.campaignStyle.length; i < len; i++) {
      let camp = this.state.campaignStyle[i];
      if (!camp.isDeleted) {
        let data = (
          <option key={camp._id} value={camp._id}>
            {camp.name}
          </option>
        );
        campaignList.push(data);
      }
    }

    let transactData = this.transactionInfo();

    if (
      this.state.userType === message.BUYER ||
      this.state.currentRole === message.BUYER
    ) {
      transactData.buyerAgent = {
        id: this.state.allTransdata.ownerId,
        fname: this.state.allTransdata.buyerAgentFirstname,
        lname: this.state.allTransdata.buyerAgentLastName,
      };
    }

    let images = [];
    if (
      this.state.propertyDataInfo !== undefined &&
      this.state.propertyDataInfo.image
    ) {
      this.state.propertyDataInfo.image.map((img, i) => {
        images.push(
          UrlConstants.AdminCreateTransactionUrl +
            "/upload?id=" +
            this.state.ownerId +
            "&img=" +
            img
        );
      });
    }
    let daysUntilStart =
      (new Date(getCurrentDate()).getTime() - new Date(transSdate).getTime()) /
      (1000 * 3600 * 24);
    var dayCounter;
    if (daysUntilStart <= 0) {
      dayCounter = 0;
    } else {
      dayCounter = daysUntilStart;
    }

    //days leader bar
    let daysDiff =
      (new Date(transEdate).getTime() - new Date(transSdate).getTime()) /
      (1000 * 3600 * 24);
    let taskStatusByDay = this.getTaskStatusByDay(
      this.props.allTask,
      this.props.transStatus
    );
    let leaderBar = [];
    if (daysDiff > 0) {
      for (let d = 0; d < daysDiff; d++) {
        let sts = taskStatusByDay[d];
        let stscls = "";

        if (sts !== undefined && sts !== null) {
          if (sts == "scheduled") {
            stscls = "blue";
          }
          if (sts == "completed") {
            stscls = "green";
          }
          if (sts == "overdue") {
            stscls = "orange";
          }
        }
        leaderBar.push(
          <li key={d}>
            <span className={stscls + " bg"} />
            <span className={`count ${d === dayCounter ? "circle" : ""}`}>
              {d}
            </span>
          </li>
        );
      }
    } else {
      let sts = !!this.props.transStatus
        ? this.props.transStatus.toLowerCase()
        : "";
      let stscls = "";
      if (sts == "inprogress") {
        stscls = "blue";
      }
      if (sts == "completed") {
        stscls = "green";
      }

      leaderBar.push(
        <li key={0}>
          <span className={stscls + " bg"} />
          <span className="count">{0}</span>
        </li>
      );
    }

    const { photoIndex, isOpen } = this.state;

    let iniVal = this.state.propertyDataInfo;
    iniVal.shortName = !!this.state.allTransdata
      ? this.state.allTransdata.shortName
      : "";

    let transInvoiceData = this.state.userTransInvoicesData;
    let rows = [];
    for (let i = 0; i < transInvoiceData.length; i++) {
      let invoice = transInvoiceData[i];

      let invoiceObject = {
        invoiceNumber: invoice.invoiceNumber ? (
          invoice.paymentStatus && invoice.paymentStatus !== "APPROVED" ? (
            <span
              onClick={() => this.setResendPaymentData(invoice)}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "blue",
              }}
            >
              {" "}
              {invoice.invoiceNumber}
            </span>
          ) : (
            invoice.invoiceNumber
          )
        ) : (
          "-"
        ),
        // paymentType: invoice.invoiceType
        //   ? toTitleCase(invoice.invoiceType)
        //   : "",
        requestedAmount: invoice.amount
          ? `$${formatNumber(invoice.amount)}`
          : "$0.00",
        amountCharged: invoice.amountCharged
          ? `$${formatNumber(invoice.amountCharged)}`
          : "$0.00",
        serviceCharge: invoice.serviceCharge
          ? `$${formatNumber(invoice.serviceCharge)}`
          : "$0.00",
        tipAmount: invoice.tipAmount
          ? `$${formatNumber(invoice.tipAmount)}`
          : "$0.00",
        description: this.getTypeDescription(invoice),
        paymentMode: invoice.paymentMethod
          ? toTitleCase(invoice.paymentMethod)
          : "",
        paymentStatus:
          invoice.paymentStatus && invoice.paymentStatus === "APPROVED" ? (
            <Tooltip title={invoice.paymentStatus}>
              <CheckCircle className="check" style={{ color: "green" }} />
            </Tooltip>
          ) : (
            <>
              <Tooltip title={invoice.paymentStatus}>
                <CheckCircleOutline className="check-out" />
              </Tooltip>
              {this.state.userType === message.VENDOR &&
              this.state.currentRole === message.BUYER &&
              invoice.paymentUrl ? (
                <Button
                  variant="info"
                  size="sm"
                  style={{
                    width: "60px",
                    padding: "0 14px",
                    marginLeft: "5px",
                  }}
                  onClick={() => {
                    window.open(`${invoice.paymentUrl}`, "_blank");
                  }}
                >
                  Pay
                </Button>
              ) : (
                ""
              )}
            </>
          ),
      };

      rows.push(invoiceObject);
    }

    return (
      <div className="trans-tab-single">
        {this.state.showLoader ? (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {/* <Row className="page-head-row page-head-row-inner align-items-center ml-0 mr-0 trans-timeline-wrapper">
							<Col xs="12">
								<div className="trans-timeline">
									<h6>Days</h6>
									<ul>{leaderBar}</ul>
								</div>
							</Col>
						</Row> */}
            <div className="container-custom admin-content-area mb-5">
              <Row className="pt-3">
                <Col xs="12" sm="3" className="mb-3">
                  <div
                    className="trans-carousel"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <Carousel
                      className="slide-transaction"
                      interval={3000}
                      indicators={false}
                      fade={true}
                      controls={
                        (this.state.propertyDataInfo !== undefined &&
                          (this.state.propertyDataInfo.image || []).length) <= 1
                          ? false
                          : true
                      }
                    >
                      {(
                        (this.state.propertyDataInfo !== undefined
                          ? this.state.propertyDataInfo.image
                          : []) || []
                      ).map((img, i) => {
                        return (
                          <Carousel.Item key={img + i}>
                            {img == null || img == "" ? (
                              <img
                                className="d-block w-100"
                                src={placeholderImage}
                              />
                            ) : (
                              <ImageLoader
                                src={
                                  UrlConstants.AdminCreateTransactionUrl +
                                  "/upload?id=" +
                                  this.state.transactionId +
                                  "&img=" +
                                  img
                                }
                              >
                                <img style={{ position: "absolute" }} />
                                <img src={placeholderImage} />
                                <Preloader />
                              </ImageLoader>
                            )}

                            {/* {this.state.userType !== message.BUYER &&
                              this.props.transStatus !== "COMPLETED" &&
                              this.state.currentRole !== message.BUYER && (
                                <div className="dropzone-options">
                                  <Button
                                    variant="transparent"
                                    className=""
                                    onClick={() =>
                                      this.setState({ isOpen: true })
                                    }
                                  >
                                    <ZoomIn />
                                  </Button>
                                  {isOpen && (
                                    <Lightbox
                                      mainSrc={images[photoIndex]}
                                      nextSrc={
                                        images[(photoIndex + 1) % images.length]
                                      }
                                      prevSrc={
                                        images[
                                          (photoIndex + images.length - 1) %
                                            images.length
                                        ]
                                      }
                                      onCloseRequest={() =>
                                        this.setState({ isOpen: false })
                                      }
                                      onMovePrevRequest={() =>
                                        this.setState({
                                          photoIndex:
                                            (photoIndex + images.length - 1) %
                                            images.length,
                                        })
                                      }
                                      onMoveNextRequest={() =>
                                        this.setState({
                                          photoIndex:
                                            (photoIndex + 1) % images.length,
                                        })
                                      }
                                    />
                                  )}
                                  <Button variant="transparent" className="">
                                    <a
                                      href={
                                        UrlConstants.AdminCreateTransactionUrl +
                                        "/upload?id=" +
                                        this.state.ownerId +
                                        "&img=" +
                                        img
                                      }
                                      style={{ color: "#fff" }}
                                    >
                                      <GetApp />
                                    </a>
                                  </Button>
                                  <Button
                                    variant="transparent"
                                    className=""
                                    onClick={() => {
                                      // if (isActive === "false") {
                                      //   toastMessage(
                                      //     code.ERROR,
                                      //     message.SUBSCRIPTION_NOT_ACTIVE
                                      //   );
                                      // } else {
                                      //   this.deleteImage(img);
                                      // }

                                      this.deleteImage(img);
                                    }}
                                  >
                                    <DeleteOutline />
                                  </Button>
                                  <Button
                                    variant="transparent"
                                    className="dropzone-options-file"
                                  >
                                    <label htmlFor="browse">
                                      <Add />
                                    </label>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id="browse"
                                      multiple
                                      onChange={(e) => {
                                        // if (isActive === "false") {
                                        //   toastMessage(
                                        //     code.ERROR,
                                        //     message.SUBSCRIPTION_NOT_ACTIVE
                                        //   );
                                        // } else {
                                        //   this.uploadImage(e);
                                        // }

                                        this.uploadImage(e);
                                      }}
                                    />
                                  </Button>
                                </div>
                              )} */}

                            {this.state.userType !== message.BUYER &&
                              this.props.transStatus !== "COMPLETED" &&
                              this.state.currentRole !== message.BUYER && (
                                <div className="dropzone-options">
                                  <Button
                                    variant="transparent"
                                    className=""
                                    onClick={() =>
                                      this.setState({ isOpen: true })
                                    }
                                  >
                                    <ZoomIn />
                                  </Button>
                                  {isOpen && (
                                    <Lightbox
                                      mainSrc={images[photoIndex]}
                                      nextSrc={
                                        images[(photoIndex + 1) % images.length]
                                      }
                                      prevSrc={
                                        images[
                                          (photoIndex + images.length - 1) %
                                            images.length
                                        ]
                                      }
                                      onCloseRequest={() =>
                                        this.setState({ isOpen: false })
                                      }
                                      onMovePrevRequest={() =>
                                        this.setState({
                                          photoIndex:
                                            (photoIndex + images.length - 1) %
                                            images.length,
                                        })
                                      }
                                      onMoveNextRequest={() =>
                                        this.setState({
                                          photoIndex:
                                            (photoIndex + 1) % images.length,
                                        })
                                      }
                                    />
                                  )}
                                  <Button variant="transparent" className="">
                                    <a
                                      href={
                                        UrlConstants.AdminCreateTransactionUrl +
                                        "/upload?id=" +
                                        this.state.ownerId +
                                        "&img=" +
                                        img
                                      }
                                      style={{ color: "#fff" }}
                                    >
                                      <GetApp />
                                    </a>
                                  </Button>
                                  {this.state.currentRole === message.Artist &&
                                  this.state.permissionarray.includes(
                                    message.manage_transactions
                                  ) ? (
                                    <>
                                      <Button
                                        variant="transparent"
                                        className=""
                                        onClick={() => {
                                          // if (isActive === "false") {
                                          //   toastMessage(
                                          //     code.ERROR,
                                          //     message.SUBSCRIPTION_NOT_ACTIVE
                                          //   );
                                          // } else {
                                          //   this.deleteImage(img);
                                          // }

                                          this.deleteImage(img);
                                        }}
                                      >
                                        <DeleteOutline />
                                      </Button>
                                      <Button
                                        variant="transparent"
                                        className="dropzone-options-file"
                                      >
                                        <label htmlFor="browse">
                                          <Add />
                                        </label>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          id="browse"
                                          multiple
                                          onChange={(e) => {
                                            // if (isActive === "false") {
                                            //   toastMessage(
                                            //     code.ERROR,
                                            //     message.SUBSCRIPTION_NOT_ACTIVE
                                            //   );
                                            // } else {
                                            //   this.uploadImage(e);
                                            // }

                                            this.uploadImage(e);
                                          }}
                                        />
                                      </Button>
                                    </>
                                  ) : this.state.userType ===
                                    message.ACCTOWNER ? (
                                    <>
                                      <Button
                                        variant="transparent"
                                        className=""
                                        onClick={() => {
                                          // if (isActive === "false") {
                                          //   toastMessage(
                                          //     code.ERROR,
                                          //     message.SUBSCRIPTION_NOT_ACTIVE
                                          //   );
                                          // } else {
                                          //   this.deleteImage(img);
                                          // }

                                          this.deleteImage(img);
                                        }}
                                      >
                                        <DeleteOutline />
                                      </Button>
                                      <Button
                                        variant="transparent"
                                        className="dropzone-options-file"
                                      >
                                        <label htmlFor="browse">
                                          <Add />
                                        </label>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          id="browse"
                                          multiple
                                          onChange={(e) => {
                                            // if (isActive === "false") {
                                            //   toastMessage(
                                            //     code.ERROR,
                                            //     message.SUBSCRIPTION_NOT_ACTIVE
                                            //   );
                                            // } else {
                                            //   this.uploadImage(e);
                                            // }

                                            this.uploadImage(e);
                                          }}
                                        />
                                      </Button>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                          </Carousel.Item>
                        );
                      })}

                      {this.state.propertyDataInfo !== undefined &&
                        (this.state.propertyDataInfo.image || []).length <=
                          0 && (
                          <Carousel.Item>
                            <img
                              className="d-block w-100"
                              src={placeholderImage}
                            />
                            {this.state.permissionarray.includes(
                              message.manage_transactions
                            )
                              ? this.state.userType !== message.BUYER &&
                                this.props.transStatus !== "COMPLETED" &&
                                this.state.currentRole !== message.BUYER && (
                                  <div className="dropzone-options">
                                    <Button
                                      variant="transparent"
                                      className="dropzone-options-file"
                                    >
                                      <label htmlFor="browse">
                                        <Add />
                                      </label>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        id="browse"
                                        multiple
                                        onChange={(e) => {
                                          // if (isActive === "false") {
                                          //   toastMessage(
                                          //     code.ERROR,
                                          //     message.SUBSCRIPTION_NOT_ACTIVE
                                          //   );
                                          // } else {
                                          //   this.uploadImage(e);
                                          // }
                                          this.uploadImage(e);
                                        }}
                                      />
                                    </Button>
                                  </div>
                                )
                              : this.state.userType === message.ACCTOWNER && (
                                  <div className="dropzone-options">
                                    <Button
                                      variant="transparent"
                                      className="dropzone-options-file"
                                    >
                                      <label htmlFor="browse">
                                        <Add />
                                      </label>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        id="browse"
                                        multiple
                                        onChange={(e) => {
                                          // if (isActive === "false") {
                                          //   toastMessage(
                                          //     code.ERROR,
                                          //     message.SUBSCRIPTION_NOT_ACTIVE
                                          //   );
                                          // } else {
                                          //   this.uploadImage(e);
                                          // }
                                          this.uploadImage(e);
                                        }}
                                      />
                                    </Button>
                                  </div>
                                )}
                          </Carousel.Item>
                        )}
                    </Carousel>
                  </div>
                </Col>

                <Col xs="12" sm="3" className="mb-3">
                  <div className="trans-edit-block">
                    <h2 className="font-20 mb-1 font-600">
                      {!!this.state.allTransdata.shortName
                        ? this.state.allTransdata.shortName
                        : ""}
                    </h2>

                    <div className="c-select status-select mt-2 mb-2">
                      <select
                        name="status"
                        id=""
                        value={this.props.transStatus}
                        className="form-control"
                        onChange={(e) => this.changeTransStatus(e)}
                        // disabled={
                        //   this.state.userType == message.BUYER ||
                        //   this.state.currentRole === message.BUYER ||
                        //   (this.state.userType == message.VENDOR &&
                        //     this.state.currentRole === message.Artist &&
                        //     !this.state.permissionarray.includes(
                        //       message.manage_transactions
                        //     )) ||
                        //   this.props.transStatus == "COMPLETED"
                        //     ? true
                        //     : false
                        // }
                        disabled={
                          this.state.userType == message.BUYER ||
                          this.state.currentRole === message.BUYER ||
                          this.state.userType === message.ADMIN ||
                          this.props.transStatus == "COMPLETED"
                            ? true
                            : false
                        }
                      >
                        {this.props.transStatus != "DRAFT" && (
                          <option value="INPROGRESS">In Progress</option>
                        )}
                        {this.props.transStatus != "SCHEDULED" &&
                          this.props.transStatus != "DRAFT" && (
                            <option value="COMPLETED">Completed</option>
                          )}
                        {this.props.transStatus != "DRAFT" && (
                          <option value="CANCELED">Canceled</option>
                        )}
                      </select>
                    </div>
                    <h4 className="font-14 color-black">Timezone</h4>

                    <div className="c-select status-select mt-2 mb-2">
                      <select
                        name="userTimezone"
                        className="form-control"
                        value={this.state.userTimezone}
                        disabled
                      >
                        {this.state.timeZoneList.map((e) => {
                          return (
                            <option key={e._id} value={e.value}>
                              {e.displayText}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <p className="mb-0 font-14">Updated on: {modifiedDate}</p>
                  </div>
                </Col>

                <Col xs="12" sm="6">
                  <div className="trans-edit-block pr-0">
                    {this.state.userType === message.BUYER ||
                    this.state.currentRole === message.BUYER ||
                    this.state.userType === message.VENDOR ||
                    this.state.currentRole === message.VENDOR ||
                    this.props.transStatus === "COMPLETED"
                      ? ""
                      : ""}
                    {this.state.userType === message.BUYER ||
                    this.state.currentRole === message.BUYER ? (
                      <>
                        <h4 className="font-14 color-blue-4">
                          Artist Information
                        </h4>
                        <h1 className="font-20 mb-1 font-600 text-capitalize">
                          {this.state.allTransdata.dsd.listingAgents[0]
                            .firstname +
                            " " +
                            this.state.allTransdata.dsd.listingAgents[0]
                              .lastname}
                        </h1>
                        <table
                          border="0"
                          className="mt-2 trans-table trans-table-normal"
                        >
                          <tbody>
                            <tr>
                              <td
                                className="text-key"
                                style={{ width: "35px" }}
                              >
                                {this.state.allTransdata.dsd.listingAgents[0]
                                  .email && (
                                  <a
                                    href={
                                      "mailto:" +
                                      this.state.allTransdata.dsd
                                        .listingAgents[0].email
                                    }
                                  >
                                    <Email />
                                  </a>
                                )}
                              </td>
                              <td className="text-val font-14">
                                <div className="email-case">
                                  {
                                    this.state.allTransdata.dsd.listingAgents[0]
                                      .email
                                  }
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-key">
                                <a
                                  style={{ color: "black" }}
                                  href={
                                    "tele: " +
                                    this.state.allTransdata.dsd.listingAgents[0]
                                      .mobileNumber
                                  }
                                >
                                  {this.state.allTransdata.dsd.listingAgents[0]
                                    .mobileNumber && <Smartphone />}
                                </a>
                              </td>
                              <td className="text-val font-14">
                                <PhoneNumber
                                  phoneNumber={
                                    this.state.allTransdata.dsd.listingAgents[0]
                                      .mobileNumber
                                  }
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table>
                          <tbody>
                            {this.state.userType === message.VENDOR ||
                            this.state.currentRole === message.VENDOR ? (
                              <tr>
                                <td style={{ width: "100%" }}>
                                  <h4 className="font-14 color-black">
                                    Client Information
                                  </h4>

                                  <h1 className="font-20 mb-1 font-600 text-capitalize">
                                    {this.state.transactiondata.dsd.buyer[0]
                                      .firstname +
                                      (this.state.transactiondata.dsd.buyer[0]
                                        .lastname
                                        ? " " +
                                          this.state.transactiondata.dsd
                                            .buyer[0].lastname
                                        : "")}

                                    {/* {getContingencyAssignee(this.state.contacts, this.state.campContingencies, "Client", "fullname")} */}
                                  </h1>
                                  <table
                                    border="0"
                                    className="mt-2 trans-table trans-table-normal"
                                  >
                                    <tbody>
                                      {this.state.transactiondata.dsd.buyer[0]
                                        .email ? (
                                        <tr>
                                          <td
                                            className="text-key"
                                            style={{ width: "35px" }}
                                          >
                                            <a
                                              className="mr-2"
                                              href={
                                                "mailto:" +
                                                this.state.transactiondata.dsd
                                                  .buyer[0].email
                                              }
                                            >
                                              <Email />
                                            </a>
                                          </td>

                                          <td className="text-val font-14">
                                            <div className="email-case">
                                              {
                                                this.state.transactiondata.dsd
                                                  .buyer[0].email
                                              }
                                            </div>
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )}
                                      {this.state.transactiondata.dsd.buyer[0]
                                        .mobileNumber ? (
                                        <tr>
                                          <td
                                            className="text-key"
                                            style={{ width: "35px" }}
                                          >
                                            <a
                                              className="mr-2"
                                              href={
                                                "tele: " +
                                                this.state.transactiondata.dsd
                                                  .buyer[0].mobileNumber
                                              }
                                            >
                                              <Smartphone />
                                            </a>
                                          </td>

                                          <td className="text-val font-14">
                                            {/* <div className="email-case">
                                            {
                                              this.state.transactiondata.dsd
                                                .buyer[0].mobileNumber
                                            }
                                          </div> */}
                                            <PhoneNumber
                                              phoneNumber={
                                                this.state.transactiondata.dsd
                                                  .buyer[0].mobileNumber
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <>
                        <Col xs="12" sm="12">
                          <h4 className="font-14 color-black">
                            Client Information
                          </h4>
                          <h1 className="font-20 mb-1 font-600 text-capitalize">
                            {this.state.transactiondata.dsd.buyer[0].firstname +
                              (this.state.transactiondata.dsd.buyer[0].lastname
                                ? " " +
                                  this.state.transactiondata.dsd.buyer[0]
                                    .lastname
                                : "")}
                            {/* {getContingencyAssignee(this.state.contacts, this.state.campContingencies, "Client", "fullname")} */}
                          </h1>
                          <table
                            border="0"
                            className="mt-2 trans-table trans-table-normal"
                          >
                            <tbody>
                              {this.state.transactiondata.dsd.buyer[0].email ? (
                                <tr>
                                  <td
                                    className="text-key"
                                    style={{ width: "35px" }}
                                  >
                                    <a
                                      className="mr-2"
                                      href={
                                        "mailto:" +
                                        this.state.transactiondata.dsd.buyer[0]
                                          .email
                                      }
                                    >
                                      <Email />
                                    </a>
                                  </td>

                                  <td className="text-val font-14">
                                    <div className="email-case">
                                      {
                                        this.state.transactiondata.dsd.buyer[0]
                                          .email
                                      }
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {this.state.transactiondata.dsd.buyer[0]
                                .mobileNumber ? (
                                <tr>
                                  <td
                                    className="text-key"
                                    style={{ width: "35px" }}
                                  >
                                    <a
                                      className="mr-2"
                                      href={
                                        "tele: " +
                                        this.state.transactiondata.dsd.buyer[0]
                                          .mobileNumber
                                      }
                                    >
                                      <Smartphone />
                                    </a>
                                  </td>

                                  <td className="text-val font-14">
                                    {/* <div className="email-case">
                                      {
                                        this.state.transactiondata.dsd.buyer[0]
                                          .mobileNumber
                                      }
                                    </div> */}
                                    <PhoneNumber
                                      phoneNumber={
                                        this.state.transactiondata.dsd.buyer[0]
                                          .mobileNumber
                                      }
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </table>
                        </Col>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                {this.state.userType === message.VENDOR &&
                this.state.currentRole === message.Artist &&
                this.state.permissionarray.includes(
                  message.manage_transactions
                ) ? (
                  <Col
                    xs="12"
                    sm="12"
                    align="right"
                    className="pl-0 align-self-end pb-3"
                  >
                    <Button
                      variant="primary"
                      className="btn-blue text-uppercase add-vendor-btn"
                      onClick={() => {
                        this.sendForms();
                      }}
                    >
                      Complete Forms
                    </Button>
                  </Col>
                ) : this.state.userType === message.ACCTOWNER ||
                  this.state.currentRole === message.ACCTOWNER ? (
                  <Col
                    xs="12"
                    sm="12"
                    align="right"
                    className="pl-0 align-self-end pb-3"
                  >
                    <Button
                      variant="primary"
                      className="btn-blue text-uppercase add-vendor-btn"
                      onClick={() => {
                        this.sendForms();
                      }}
                    >
                      Complete Forms
                    </Button>
                  </Col>
                ) : (
                  ""
                )}
              </Row>

              <hr className="row my-0" />
              <Row>
                {this.state.userType === message.ACCTOWNER ||
                this.state.currentRole === message.ACCTOWNER ||
                this.state.userType === message.BUYER ||
                this.state.currentRole === message.BUYER ||
                this.state.userType === message.VENDOR ? (
                  <Col xs="12" sm="3" className="pt-3 trans-edit-left">
                    <div className="mb-4 trans-edit-block">
                      {this.state.userType === message.BUYER ||
                      this.state.currentRole === message.BUYER ||
                      (this.state.userType === message.VENDOR &&
                        this.state.currentRole === message.Artist &&
                        !this.state.permissionarray.includes(
                          message.manage_transactions
                        )) ||
                      this.props.transStatus === "COMPLETED" ? (
                        ""
                      ) : (
                        <Button
                          variant="transparent"
                          className="edit-icn p-0"
                          onClick={() => this.agreedInfoModal()}
                        >
                          <Edit />
                        </Button>
                      )}
                      <table className="trans-table">
                        <tbody>
                          <tr>
                            <td className="text-key blue">
                              Artwork Information:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-key font-14 font-500">
                              Appointment Type:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-val font-16 color-black">
                              {this.state.allTransdata.transactionType}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-key font-14 font-500">
                              Description:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-val font-16 color-black">
                              {!!this.state.allTransdata.dsd.heldBy
                                ? this.state.allTransdata.dsd.heldBy
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="mb-4 trans-edit-block">
                      <table className="font-14 trans-table">
                        <tbody>
                          <tr>
                            <td className="text-key font-14 font-500">
                              Total Cost:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-val font-22 font-600">
                              $
                              {formatNumber(
                                this.state.allTransdata.dsd.agreedOpenPrice
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-key font-14 font-500">
                              Deposit:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-val font-16 color-black">
                              $
                              {formatNumber(
                                (this.props.transPaymentData &&
                                  this.props.transPaymentData.totalDeposit) ||
                                  "0"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-key font-14 font-500">Fees:</td>
                          </tr>
                          {this.props.transactionData.dsd.fees.map(
                            (feesName, ind) => {
                              if (feesName.name !== "Brokerage Fee") {
                                return (
                                  <tr>
                                    <td className="text-val font-16 color-black">
                                      {feesName.name +
                                        ": " +
                                        "$" +
                                        formatNumber(feesName.value)}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          )}
                          <tr>
                            <td className="text-key font-14 font-500">
                              Total Payments Made:
                            </td>
                          </tr>
                          <tr>
                            <td className="text-val font-16 color-black">
                              $
                              {formatNumber(
                                (this.props.transPaymentData &&
                                  this.props.transPaymentData
                                    .totalCostAmount) ||
                                  "0"
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-key font-14 font-500">
                              Balance Owed:
                              <div className="text-val font-16 color-black">
                                ${formatNumber(this.calculateOwedBalance())}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      onClick={() => {
                        this.resetForm();
                        this.setState({
                          transactionPayment: initialTransactionPaymentData,
                        });
                        this.loadUserTransInvoiceList();
                        this.despositPaymentModal();
                      }}
                    >
                      {this.state.userType === message.VENDOR &&
                      this.state.currentRole === message.BUYER
                        ? "Payment History"
                        : "Pay"}
                    </Button>
                  </Col>
                ) : (
                  ""
                )}

                {this.state.userType === message.ACCTOWNER ||
                this.state.currentRole === message.ACCTOWNER ||
                this.state.userType === message.BUYER ||
                this.state.currentRole === message.BUYER ||
                this.state.userType === message.VENDOR ? (
                  <Col xs="12" sm="9" className="pt-3 set-contingencies-detail">
                    {this.props.updated ? (
                      <UpdateContingencies
                        isMasterTemplate={false}
                        isUpdateTrans={true}
                        updateTransactionData={(k, v) =>
                          this.updateTransactionData(k, v)
                        }
                        campContingencies={this.props.updatedData.contingencies}
                        transID={this.state.allTransdata._id}
                        transdata={this.state.allTransdata}
                        contiCamp={(data, keys) =>
                          this.updateTranConData(data, keys)
                        }
                        updateClientData={(data, keys) =>
                          this.updateClientData(data, keys)
                        }
                        updateClientId={(data, keys) =>
                          this.updateClientId(data, keys)
                        }
                        updateArtistData={(data, keys) =>
                          this.updateArtistData(data, keys)
                        }
                        updateGuardianData={(data, keys) =>
                          this.updateGuardianData(data, keys)
                        }
                        startDate={this.state.transactionDataInfo.startDate}
                        endDate={this.state.transactionDataInfo.closeDate}
                        transStatus={this.props.transStatus}
                        campaignStyle={this.state.campaignStyle}
                        getTransactionData={() => {
                          return transactData;
                        }}
                      />
                    ) : (
                      <UpdateContingencies
                        isMasterTemplate={false}
                        isUpdateTrans={true}
                        updateTransactionData={(k, v) =>
                          this.updateTransactionData(k, v)
                        }
                        campContingencies={this.state.campContingencies}
                        transID={this.state.allTransdata._id}
                        transdata={this.state.allTransdata}
                        contiCamp={(data, keys) =>
                          this.updateTranConData(data, keys)
                        }
                        updateClientData={(data, keys) =>
                          this.updateClientData(data, keys)
                        }
                        updateClientId={(data, keys) =>
                          this.updateClientId(data, keys)
                        }
                        updateArtistData={(data, keys) =>
                          this.updateArtistData(data, keys)
                        }
                        updateGuardianData={(data, keys) =>
                          this.updateGuardianData(data, keys)
                        }
                        startDate={this.state.transactionDataInfo.startDate}
                        endDate={this.state.transactionDataInfo.closeDate}
                        transStatus={this.props.transStatus}
                        campaignStyle={this.state.campaignStyle}
                        getTransactionData={() => {
                          return transactData;
                        }}
                      />
                    )}
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>

            {/* Property Information modal */}
            <Modal
              show={this.state.propertyInfo}
              onHide={() => this.propertyInfoModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med1"
            >
              <Formik
                validateOnBlur={true}
                initialValues={iniVal}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  street: Yup.string().required(message.ENTER_ADDRESS_LINE),
                  zipcode: Yup.string()
                    .required(message.ENTER_ZIP)
                    .matches(new RegExp("^[0-9]{5}(?:-[0-9]{4})?$"), {
                      message: message.ENTER_VALID_ZIP,
                      excludeEmptyString: true,
                    }),
                  city: Yup.string().required(message.ENTER_CITY),
                  state: Yup.string().required(message.SELECT_STATE),
                })}
                onSubmit={(values) => {
                  let difference = Object.keys(
                    this.state.propertyDataInfo
                  ).filter((k) => this.state.propertyDataInfo[k] !== values[k]);
                  this.setState({ updatedKeys: difference, showLoader: true });
                  this.updateAPI(values, "property");
                }}
              >
                {({
                  handleChange,
                  errors,
                  values,
                  handleBlur,
                  setFieldValue,
                  submitForm,
                  touched,
                  loginError,
                  setFieldError,
                  setErrors,
                }) => (
                  <Form className="form-sm form-admin">
                    <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                        Edit Property Information
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-0">
                      <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="shortName">
                              Short Name (Max 10 Characters)
                              <span className="text-danger">*</span>
                            </label>
                            <Field
                              name="shortName"
                              type="text"
                              disabled
                              value={values.shortName}
                              className={
                                "form-control" +
                                (errors.shortName && touched.shortName
                                  ? " is-invalid"
                                  : "")
                              }
                            />

                            {this.state.shortNameAccepted !== undefined &&
                            !this.state.shortNameAccepted ? (
                              <span
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                {
                                  "The selected transaction name is already in use, Please use another name"
                                }
                              </span>
                            ) : (
                              ""
                            )}
                            <ErrorMessage
                              name="shortName"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="street">
                              Address 1<span className="text-danger"> *</span>
                            </label>
                            <Field
                              name="street"
                              type="text"
                              value={values.street}
                              className={
                                "form-control field_ucfirst" +
                                (errors.street && touched.street
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="street"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="street1">
                              Address 2
                            </label>
                            <Field
                              name="street1"
                              type="text"
                              value={values.street1}
                              className={
                                "form-control field_ucfirst" +
                                (errors.street1 && touched.street1
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="street1"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={4}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="zipcode">
                              Zip Code<span className="text-danger">*</span>
                            </label>
                            <input
                              name="zipcode"
                              type="text"
                              value={values.zipcode}
                              onChange={(e) => {
                                setFieldValue("zipcode", e.target.value);
                                let zipcode = e.target.value;
                                let checkZip = zipcode.toString();
                                checkZip = checkZip.replace(/\-/g, "");
                                if (
                                  zipcode != "00000" &&
                                  (checkZip.length === 5 ||
                                    checkZip.length === 9)
                                ) {
                                  this.props
                                    .getAddressFromZipcodeAction(checkZip)
                                    .then((res) => {
                                      setFieldValue("city", res.city);
                                      setFieldValue("state", res.state);
                                    });
                                } else {
                                  setFieldValue("city", "");
                                  setFieldValue("state", "");
                                }
                              }}
                              className={
                                "form-control" +
                                (errors.zipcode && touched.zipcode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="zipcode"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={4}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="city">
                              City<span className="text-danger">*</span>
                            </label>
                            <Field
                              name="city"
                              type="text"
                              value={values.city}
                              className={
                                "form-control field_ucfirst" +
                                (errors.city && touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={4}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="state">
                              State<span className="text-danger">*</span>
                            </label>
                            <div className="c-select">
                              <select
                                name="state"
                                id=""
                                value={values.state}
                                disabled={
                                  this.state.userType == message.BUYER ||
                                  this.state.currentRole === message.BUYER
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  setFieldValue("state", e.target.value);
                                }}
                                className="form-control"
                              >
                                <option value="">Select</option>
                                {stateDropDownValue}
                              </select>
                            </div>
                            <ErrorMessage
                              name="state"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        type="submit"
                        size="sm"
                        className="btn-blue w-140"
                      >
                        Update
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            {/* Buyer Information modal */}
            <Modal
              show={this.state.buyerInfo}
              onHide={() => this.buyerInfoModal()}
              initialValues={this.state.buyerDataInfo}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
            >
              <Formik
                validateOnBlur={true}
                initialValues={this.state.buyerDataInfo}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  firstname: Yup.string().required(
                    message.ENTER_CLIENT_FIRST_NAME
                  ),
                  lastName: Yup.string().required(
                    message.ENTER_CLIENT_LAST_NAME
                  ),
                  email: Yup.string().required(message.ENTER_EMAIL),
                  mobileNumber: Yup.string().required(
                    message.ENTER_VALID_MOBILE
                  ),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  let difference = Object.keys(this.state.buyerDataInfo).filter(
                    (k) => this.state.buyerDataInfo[k] !== values[k]
                  );
                  this.setState({ updatedKeys: difference, showLoader: true });
                  this.updateAPI(values, "buyer");
                }}
              >
                {({
                  handleChange,
                  errors,
                  values,
                  handleBlur,
                  setFieldValue,
                  submitForm,
                  touched,
                  loginError,
                }) => (
                  <Form className="form-sm form-admin">
                    <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                        Buyer Information
                      </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="pb-0">
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="firstname">
                              Buyers First Name
                              <span className="text-danger">*</span>
                            </label>
                            <Field
                              name="firstname"
                              type="text"
                              value={values.firstname}
                              className={
                                "form-control field_ucfirst" +
                                (errors.firstname && touched.firstname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="firstname"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="lastName">
                              Buyers Last Name
                              <span className="text-danger">*</span>
                            </label>
                            <Field
                              name="lastName"
                              type="text"
                              value={values.lastName}
                              className={
                                "form-control field_ucfirst" +
                                (errors.lastName && touched.lastName
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="lastName"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="email">
                              E-mail Address
                              <span className="text-danger">*</span>
                            </label>
                            <Field
                              name="email"
                              type="text"
                              value={values.email}
                              className={
                                "form-control" +
                                (errors.email && touched.email
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label
                              className="form-label"
                              htmlFor="mobileNumber"
                            >
                              Mobile Number
                              <span className="text-danger">*</span>
                            </label>
                            <InputMask
                              mask="999-999-9999"
                              maskChar=""
                              className={
                                "form-control" +
                                (errors.mobileNumber && touched.mobileNumber
                                  ? " is-invalid"
                                  : "")
                              }
                              formControlProps={{
                                fullWidth: true,
                              }}
                              value={values.mobileNumber}
                              name="mobileNumber"
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              {(inputProps) => <Field {...inputProps} />}
                            </InputMask>

                            <ErrorMessage
                              name="mobileNumber"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        type="submit"
                        size="sm"
                        className="btn-blue w-140"
                      >
                        Update
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            <Modal
              show={this.state.agreedInfo}
              onHide={() => this.agreedInfoModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
            >
              <Formik
                validateOnBlur={true}
                initialValues={this.state.priceDataInfo}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  agreedOpenPrice: Yup.number()
                    .required("Please enter Agreed Open Price")
                    .min(1.0, "Please enter valid Agreed Open Price"),
                  // emd: Yup.number()
                  //   .required("Please enter EMD Deposit")
                  //   .min(0, "Please enter valid EMD Deposit")
                  //   .max(
                  //     this.state.priceDataInfo.agreedOpenPrice,
                  //     `Deposit can't be greater than total cost`
                  //   ),

                  // emd: Yup.number()
                  //   .required("Please enter EMD Deposit")
                  //   .min(0, "Please enter valid EMD Deposit")
                  //   .test(
                  //     "is-greater-than-value1",
                  //     "Deposit can't be greater than total cost",
                  //     function(value) {
                  //       return value <= this.parent.agreedOpenPrice;
                  //     }
                  //   ),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  let difference = Object.keys(this.state.priceDataInfo).filter(
                    (k) => this.state.priceDataInfo[k] !== values[k]
                  );
                  this.setState({ updatedKeys: difference, showLoader: true });
                  this.updateAPI(values, "price");
                }}
              >
                {({
                  handleChange,
                  errors,
                  values,
                  handleBlur,
                  setFieldValue,
                  submitForm,
                  touched,
                }) => (
                  <Form className="form-sm form-admin">
                    <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                        Edit Artwork Information
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-0">
                      <Row>
                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label
                              className="form-label"
                              htmlFor="mobileNumber"
                            >
                              Total Cost
                              <span className="text-danger"> *</span>
                            </label>

                            {this.state.salePriceFocus ? (
                              <NumericInput
                                name="agreedOpenPrice"
                                inputmode="numeric"
                                strict
                                step={0.1}
                                precision={2}
                                style={false}
                                className={
                                  "form-control text-right sales-input" +
                                  (errors.agreedOpenPrice &&
                                  touched.agreedOpenPrice
                                    ? " is-invalid"
                                    : "")
                                }
                                value={
                                  values.agreedOpenPrice
                                    ? values.agreedOpenPrice
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue("agreedOpenPrice", e);
                                }}
                                onBlur={() => {
                                  this.setState({ salePriceFocus: false });
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                name="agreedOpenPrice"
                                className={
                                  "form-control text-right " +
                                  (errors.agreedOpenPrice &&
                                  touched.agreedOpenPrice
                                    ? " is-invalid"
                                    : "")
                                }
                                onFocus={() => {
                                  this.setState(
                                    { salePriceFocus: true },
                                    () => {
                                      $(".sales-input").focus();
                                    }
                                  );
                                }}
                                onMouseEnter={() => {
                                  this.setState({ salePriceFocus: false });
                                }}
                                defaultValue={
                                  values.agreedOpenPrice
                                    ? currencyFormat(values.agreedOpenPrice)
                                    : ""
                                }
                              />
                            )}

                            <ErrorMessage
                              name="agreedOpenPrice"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>

                        {/* <Col xs={12} sm={6}>
													<div className="form-group">
														<label className="form-label" htmlFor="commission">
															Commission (%)
															<span className="text-danger"> *</span>
														</label>
														<NumericInput
															name="commission"
															precision={2}
															min={0}
															max={100}
															inputMode="numeric"
															strict
															style={false}
															className="form-control"
															value={values.commission}
															onChange={e => {
																setFieldValue("commission", e);
															}}
														/>
														<ErrorMessage
															name="commission"
															component="div"
															className="invalid-feedback"
															style={{ display: "block" }}
														/>
													</div>
												</Col> */}

                        {/* <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="emd">
                              Deposit<span className="text-danger"> *</span>
                            </label>

                            {this.state.emdFocus ? (
                              <input
                                type="number"
                                name="emd"
                                min={0}
                                className={
                                  "form-control text-right emd-input" +
                                  (errors.emd && touched.emd
                                    ? " is-invalid"
                                    : "")
                                }
                                value={values.emd ? values.emd : 0}
                                onChange={(e) => {
                                  setFieldValue("emd", e.target.value);
                                }}
                                onBlur={() => {
                                  this.setState({ emdFocus: false });
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                name="emd_price"
                                className={
                                  "form-control text-right " +
                                  (errors.emd && touched.emd
                                    ? " is-invalid"
                                    : "")
                                }
                                onFocus={() => {
                                  this.setState({ emdFocus: true }, () => {
                                    $(".emd-input").focus();
                                  });
                                }}
                                value={currencyFormat(values.emd)}
                                defaultValue={
                                  values.emd
                                    ? currencyFormat(values.emd)
                                    : currencyFormat(0)
                                }
                              />
                            )}

                            <ErrorMessage
                              name="emd"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col> */}

                        <Col xs={12} sm={6}>
                          <div className="form-group">
                            <label className="form-label" htmlFor="heldBy">
                              Description
                            </label>
                            <input
                              type="text"
                              name="heldBy"
                              id=""
                              className="form-control"
                              defaultValue={values.heldBy}
                              disabled={
                                this.state.userType == message.BUYER ||
                                this.state.currentRole === message.BUYER
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                setFieldValue("heldBy", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="heldBy"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* <Row>
                        <Col xs={12}>
                          <div className="brokerage-fees mb-3 ">
                            {this.state.otherEMD &&
                              this.state.otherEMD.length > 0 && (
                                <div className="brokerage-fees-body">
                                  {this.state.otherEMD &&
                                    this.state.otherEMD.map((name, ind) => {
                                      if (name !== null) {
                                        return (
                                          <div
                                            className="brokerage-fees-row "
                                            key={"broker-fees-" + ind}
                                          >
                                            <ul>
                                              <li className="title">
                                                {name.name}
                                              </li>
                                              <li className="value">
                                                ${formatNumber(name.value)}
                                              </li>
                                              <li className="status">
                                                <Button
                                                  variant="transparent"
                                                  onClick={(e) =>
                                                    this.deleteFeesRecord(
                                                      e,
                                                      ind,
                                                      name
                                                    )
                                                  }
                                                >
                                                  <Clear className="clear" />
                                                </Button>
                                              </li>
                                            </ul>
                                          </div>
                                        );
                                      }
                                    })}
                                </div>
                              )}

                            <div className="brokerage-fees-footer">
                              <div className="brokerage-fees-row other-deposit-label">
                                <label className="form-label">
                                  Payments (Use Whole Numbers for Amount)
                                </label>
                                <ul>
                                  <li className="title">
                                    <input
                                      type="text"
                                      className={
                                        "form-control " +
                                        this.state.nameErrClass
                                      }
                                      placeholder="Memo"
                                      defaultValue={label}
                                      onChange={() => this.draftedEMD()}
                                      onKeyDown={(e) => {
                                        if (e.keyCode == 13) {
                                          e.preventDefault();
                                          if (this.state.isEdit) {
                                            this.updateFeesRecord(e);
                                          } else {
                                            this.addOtherEMD(e);
                                          }
                                        }
                                      }}
                                    />
                                  </li>
                                  <li className="value">
                                    <input
                                      type="number"
                                      className={
                                        "form-control " + this.state.valErrClass
                                      }
                                      placeholder="Amount"
                                      defaultValue={val}
                                      onChange={() => this.draftedEMD()}
                                      onKeyDown={(e) => {
                                        if (e.keyCode == 13) {
                                          e.preventDefault();
                                          if (this.state.isEdit) {
                                            this.updateFeesRecord(e);
                                          } else {
                                            this.addOtherEMD(e);
                                          }
                                        }
                                      }}
                                    />
                                  </li>
                                  <li className="status">
                                    <Button
                                      variant="transparent"
                                      onClick={(e) => {
                                        if (this.state.isEdit) {
                                          this.updateFeesRecord(e);
                                        } else {
                                          this.addOtherEMD(e);
                                        }
                                      }}
                                    >
                                      <AddCircleOutline className="add" />
                                    </Button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row> */}
                      <BrokerageFees
                        isCreate={false}
                        addCls={true}
                        salePrice={values.agreedOpenPrice}
                        commission={values.commission}
                        getTransactionData={() => {
                          return this.state.allTransdata;
                        }}
                        updateTransactionData={(k, v) =>
                          this.updateTransactionData(k, v)
                        }
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        type="submit"
                        size="sm"
                        className="btn-blue w-140"
                      >
                        Update
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            {/* campaign change confirmation modal */}
            <Modal
              show={this.state.showCampaignModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400 modal-delete"
              centered
              backdrop={false}
            >
              <Modal.Body className="pb-0 text-center">
                <p>{this.state.campaignModalMsg}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.closeCampaignModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.setState({ showCampaignModal: false });
                    this.setContingencyForCamp(
                      this.state.campaignValues.campaign
                    );
                    let difference = Object.keys(
                      this.state.transactionDataInfo
                    ).filter(
                      (k) =>
                        this.state.transactionDataInfo[k] !==
                        this.state.campaignValues[k]
                    );
                    this.setState({
                      updatedKeys: difference,
                      showLoader: true,
                    });

                    this.updateAPI(this.state.campaignValues, "trans");
                  }}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Start transaction Confirmation */}
            <Modal
              show={this.state.startTransaction}
              onHide={() => this.closeConfirmPopup()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med"
            >
              <Formik
                validateOnBlur={true}
                initialValues={this.state.initialValues}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({})}
                onSubmit={(values, { setSubmitting }) => {
                  this.changeTransactionStatus(values);
                }}
              >
                {({
                  handleChange,
                  errors,
                  values,
                  handleBlur,
                  setFieldValue,
                  submitForm,
                  touched,
                  loginError,
                }) => (
                  <Form className="form-sm form-admin">
                    <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                        Update Artwork Status
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-0">
                      <div>
                        <p className="font-14 color-grey-2">
                          {this.state.promptMsg}
                        </p>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        type="submit"
                        variant="primary"
                        className="btn-blue btn-outlined w-140"
                      >
                        Yes
                      </Button>
                      <Button
                        variant="primary"
                        className="btn-blue w-140"
                        onClick={() => this.closeConfirmPopup()}
                      >
                        No
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            <Modal
              show={this.state.clientDataMissingPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400 modal-delete"
              centered
              backdrop={false}
            >
              <Modal.Body className="pb-0 text-center">
                <Info />
                <p>There is no email or mobile number for the client.</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.setState({ clientDataMissingPrompt: false });
                  }}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.despositPaymentModal}
              onHide={() => this.despositPaymentModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-786"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                  {this.state.userType === message.VENDOR &&
                  this.state.currentRole === message.BUYER
                    ? "Payment History"
                    : "Payment"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pb-0 mb-5">
                {this.state.userType === message.VENDOR &&
                this.state.currentRole === message.BUYER ? (
                  ""
                ) : (
                  <>
                    <Formik
                      validateOnBlur={true}
                      initialValues={this.state.transactionPayment}
                      enableReinitialize={true}
                      validationSchema={Yup.object().shape({
                        paymentType: Yup.string()
                          .trim()
                          .required(message.ENTER_PAYMENT_TYPE),
                        amount: Yup.string()
                          .required(message.ENTER_AMOUNT)
                          .matches(
                            new RegExp(
                              "^([1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$"
                            ),
                            {
                              message: message.ENTER_VALID_AMOUNT,
                            }
                          ),
                        paymentMode: Yup.string()
                          .trim()
                          .required(message.ENTER_PAYMENT_MODE),
                      })}
                      onSubmit={(values) => {
                        this.userTransactionPayment(values);
                      }}
                    >
                      {({
                        handleChange,
                        errors,
                        touched,
                        values,
                        setFieldValue,
                      }) => (
                        <Form className="form-sm form-admin">
                          <Row>
                            <Col xs={4}>
                              <div className="form-group">
                                <label className="form-label">
                                  Payment Mode
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="c-select">
                                  <Field
                                    component="select"
                                    className="form-control"
                                    value={
                                      values.paymentMode
                                        ? values.paymentMode
                                        : ""
                                    }
                                    name="paymentMode"
                                    handleChange={handleChange}
                                  >
                                    {this.renderOptions()}
                                  </Field>
                                </div>
                                <ErrorMessage
                                  name="paymentMode"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <label className="form-label">
                                  Payment Type
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="c-select">
                                  <Field
                                    component="select"
                                    className="form-control"
                                    name="paymentType"
                                    // handleChange={handleChange}
                                    value={values.paymentType}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "paymentType",
                                        e.target.value
                                      );
                                      this.setAmount(
                                        e.target.value,
                                        setFieldValue
                                      );
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="DEPOSIT">Deposit</option>
                                    <option value="PARTIAL PAYMENT">
                                      Partial Payment
                                    </option>
                                    <option value="FULL PAYMENT">
                                      Full Payment
                                    </option>
                                  </Field>
                                </div>
                                <ErrorMessage
                                  name="paymentType"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <label className="form-label" htmlFor="amount">
                                  Amount<span className="text-danger"> *</span>
                                </label>

                                {this.state.amountFocus ? (
                                  <input
                                    type="text"
                                    name="amount"
                                    className={
                                      "form-control text-right amount-input" +
                                      (errors.amount && touched.amount
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={values.amount ? values.amount : ""}
                                    onChange={(e) => {
                                      this.resetForm();
                                      setFieldValue("amount", e.target.value);
                                    }}
                                    onBlur={() => {
                                      this.setState({
                                        amountFocus: false,
                                      });
                                    }}
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    name="amount"
                                    className={
                                      "form-control text-right " +
                                      (errors.amount && touched.amount
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onFocus={() => {
                                      this.setState(
                                        { amountFocus: true },
                                        () => {
                                          $(".amount-input").focus();
                                        }
                                      );
                                    }}
                                    value={currencyFormat(values.amount)}
                                    defaultValue={
                                      values.amount
                                        ? currencyFormat(values.amount)
                                        : currencyFormat(0)
                                    }
                                  />
                                )}
                                <ErrorMessage
                                  name="amount"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                                {this.state.formErrors &&
                                  this.state.formErrors.amount && (
                                    <div
                                      className="invalid-feedback"
                                      style={{ display: "block" }}
                                    >
                                      {this.state.formErrors.amount}
                                    </div>
                                  )}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12}>
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="description"
                                >
                                  Description
                                </label>
                                <input
                                  type="text"
                                  name="description"
                                  id=""
                                  className="form-control"
                                  defaultValue={values.description}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "description",
                                      e.target.value
                                    );
                                  }}
                                />
                                <ErrorMessage
                                  name="description"
                                  component="div"
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={3}>
                              <Button
                                variant="primary"
                                size="sm"
                                className="btn-blue w-140"
                                type="submit"
                                // onClick={() => {
                                //   this.userTransactionPayment(values);
                                // }}
                                disabled={this.state.disableBtn}
                              >
                                {values.paymentMode === "CARD"
                                  ? "Generate Link"
                                  : "Save"}
                              </Button>
                            </Col>
                            <Col xs={3}>
                              <Button
                                variant="outlined"
                                size="sm"
                                className="btn-blue w-140"
                                onClick={() => this.despositPaymentModal()}
                              >
                                Cancel
                              </Button>
                            </Col>
                            {this.state.paymentSuccessMsg && (
                              <Col xs={6}>{this.state.paymentSuccessMsg}</Col>
                            )}
                          </Row>
                          {values.paymentMode === "CARD" && (
                            <>
                              <Row className="mt-3">
                                <Col xs={4}>
                                  <Button
                                    variant="info"
                                    size="sm"
                                    className="w-140"
                                    disabled={!this.state.generateLink}
                                    onClick={() => {
                                      window.open(
                                        `${this.state.paymentUrl}`,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    Open Link
                                  </Button>
                                </Col>
                                <Col xs={4}>
                                  <Button
                                    variant="info"
                                    size="sm"
                                    className="w-140"
                                    disabled={!this.state.generateLink}
                                    onClick={() => {
                                      this.setState({
                                        sendEmailPropmt: !this.state
                                          .sendEmailPropmt,
                                      });
                                      values.email = this.checkClientDetailsExists(
                                        "email"
                                      )
                                        ? this.state.transactiondata.dsd
                                            .buyer[0].email
                                        : "";
                                    }}
                                  >
                                    Send Email
                                  </Button>
                                </Col>
                                <Col xs={4}>
                                  <Button
                                    variant="info"
                                    size="sm"
                                    className="w-140"
                                    disabled={!this.state.generateLink}
                                    onClick={() => {
                                      this.setState({
                                        sendTextPrompt: !this.state
                                          .sendTextPrompt,
                                      });
                                      values.mobileNumber = this.checkClientDetailsExists(
                                        "mobile"
                                      )
                                        ? this.state.transactiondata.dsd
                                            .buyer[0].mobileNumber
                                        : "";
                                    }}
                                  >
                                    Send Text
                                  </Button>
                                </Col>
                              </Row>
                              <Row className="mt-3">
                                <Col xs={4} />
                                <Col xs={4}>
                                  {this.state.sendEmailPropmt && (
                                    <>
                                      <Row
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        <Field
                                          type="text"
                                          className="form-control"
                                          name="email"
                                          value={values.email}
                                          handleChange={handleChange}
                                          style={{ width: "76%" }}
                                        />
                                        <Button
                                          variant="primary"
                                          className="btn-blue btn-head"
                                          onClick={() => {
                                            this.sendPaymentLink(
                                              "EMAIL",
                                              values
                                            );
                                          }}
                                          style={{
                                            backgroundColor: "black",
                                            border: "none",
                                            marginTop: "1px",
                                          }}
                                        >
                                          <Send style={{ color: "white" }} />
                                        </Button>
                                      </Row>

                                      <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="invalid-feedback"
                                        style={{ display: "block" }}
                                      />
                                      {this.state.formErrors &&
                                        this.state.formErrors.email && (
                                          <div
                                            className="invalid-feedback"
                                            style={{ display: "block" }}
                                          >
                                            {this.state.formErrors.email}
                                          </div>
                                        )}
                                    </>
                                  )}
                                </Col>
                                <Col xs={4}>
                                  {this.state.sendTextPrompt && (
                                    <>
                                      <Row
                                        style={{
                                          paddingLeft: "10px",
                                          paddingRight: "10px",
                                        }}
                                      >
                                        <InputMask
                                          mask="999-999-9999"
                                          maskChar=""
                                          className={
                                            "form-control" +
                                            (errors.mobileNumber &&
                                            touched.mobileNumber
                                              ? " is-invalid"
                                              : "")
                                          }
                                          formControlProps={{
                                            fullWidth: true,
                                          }}
                                          value={values.mobileNumber}
                                          name="mobileNumber"
                                          onChange={(e) => {
                                            this.setMobile(
                                              e.target.value,
                                              "mobileNumber",
                                              setFieldValue
                                            );
                                          }}
                                          style={{ width: "76%" }}
                                        >
                                          {(inputProps) => (
                                            <Field {...inputProps} />
                                          )}
                                        </InputMask>
                                        <Button
                                          variant="primary"
                                          className="btn-blue btn-head"
                                          onClick={() => {
                                            this.sendPaymentLink(
                                              "TEXT",
                                              values
                                            );
                                          }}
                                          style={{
                                            backgroundColor: "black",
                                            border: "none",
                                            marginTop: "1px",
                                          }}
                                        >
                                          <Send style={{ color: "white" }} />
                                        </Button>
                                      </Row>

                                      <ErrorMessage
                                        name="mobileNumber"
                                        component="div"
                                        className="invalid-feedback"
                                        style={{ display: "block" }}
                                      />
                                      {this.state.formErrors &&
                                        this.state.formErrors.mobileNumber && (
                                          <div
                                            className="invalid-feedback"
                                            style={{ display: "block" }}
                                          >
                                            {this.state.formErrors.mobileNumber}
                                          </div>
                                        )}
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Form>
                      )}
                    </Formik>
                    <hr />
                  </>
                )}

                <div>
                  {this.state.userType === message.VENDOR &&
                  this.state.currentRole === message.BUYER ? (
                    ""
                  ) : (
                    <>
                      <h5>Payment History</h5>{" "}
                    </>
                  )}
                  <DataTable
                    columns={this.columns}
                    data={rows}
                    sortIcon={<KeyboardArrowDown className="color-grey-1" />}
                    noDataComponent={
                      <div
                        className="no-transaction no-record no-datatable"
                        style={{ minHeight: 0 }}
                      >
                        <div className="no-transaction-inner">
                          <p>No records found</p>
                        </div>
                      </div>
                    }
                    highlightOnHover={true}
                    className="rdt-requests"
                  />
                </div>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.reducer.transactionData,
    buyerMasterTemplates: state.reducer.buyerMasterTemplates,
    totalBuyerTemplates: state.reducer.totalBuyerTemplates,
    updatedTransData: state.reducer.updatedTransData,
    profileData: state.reducer.profileData,
    addressData: state.reducer.addressData,
    timezoneList: state.reducer.timezoneList,
    transactionType: state.reducer.transactionType,
    contacts: state.reducer.contacts,
    profileData: state.reducer.profileData,
    transPaymentData: state.reducer.transPaymentData,
  };
};

export default connect(
  mapStateToProps,
  {
    getTransactionDataAction,
    updateTransactionDataAction,
    getBuyerAgentMasterTemplateAction,
    changeTransactionStatusAction,
    getLeadSourceOptionsAction,
    getAddressFromZipcodeAction,
    getContactByEmailAction,
    getSubscriptionCounterAction,
    getTimezoneListAction,
    getTransactionTypeAction,
    getContactsActions,
    myProfileAction,
    createTaskAction,
    addPublicFormAction,
    userTransactionPaymentAction,
    getUserTransInvoiceAction,
    getUserTransPaymentStatusAction,
    sendTransPaymentLinkAction,
    getTransTotalPaymentAction,
    getBillingPaymentStatusDetails,
  }
)(TransactionDetailTab);
